// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.ChatBar-Main-Container {
  width: 376px;
  height: auto;
  flex-shrink: 0;
  border-right: 1px solid #e5e9ec;
  background: #fff;
  overflow: hidden;
}

.avatarContainer .MuiAvatar-root > svg {
  width: 100%;
  height: 100%;
  display: block;
}
.message-status {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 4px;
}

.read-status,
.delivered-status {
  margin-right: 5px;
}

.sent-indicator {
  color: #757575;
  font-size: 11px;
}
.Chatbar-Heading {
  color: #061522;

  font-size: 24px;
  font-style: normal;
  font-weight: 500;
  line-height: 18px; /* 75% */
  padding-left: 24px;
}
.Message-Container {
  display: flex;
  justify-content: flex-start;
  gap: 5px;
}

.agent-message {
  justify-content: flex-end;
}

.user-message {
  justify-content: flex-start;
}

.private-message {
  justify-content: flex-end;
}

.Message-Content {
  /* padding: 10px; */
  /* max-width: 300px; */
  /* max-width: 70%;  */
}

.mapImg {
  width: 100%;
  height: 100%;
  object-fit: cover;
}

.Chat-Attachment {
  width: 98px;
  height: 98px;
  border-radius: 8px;
  float: right;
  margin-bottom: 4px;
}

.Clear-Right {
  clear: right;
}

.Img-Content-Agent {
  max-width: fit-content;
  /* height: 296px; */
  background: #148dfd;
  color: #fff;
  padding: 15px;
  border-radius: 8px;
  width: 336px;
  position: relative;
}
.Img-Content {
  max-width: fit-content;
  /* height: 296px; */
  background: #f1f3f5;
  padding: 15px;
  border-radius: 8px;
  position: relative;
  width: 336px;
}

.Message-Img-Content {
  padding: 10px;
  max-width: 300px;
  background-color: #148dfd;
  border-radius: 16px 0px 16px 16px;
  color: #fff;
  font-size: 14px;
  font-style: normal;
  font-weight: 400;
  line-height: 18px;
  white-space: pre-wrap;
  overflow-wrap: break-word;
}

.agent-message .Message-Content {
  background-color: #148dfd;
  border-radius: 16px 16px 0px 16px;
  color: #fff;
  font-size: 14px;
  font-style: normal;
  font-weight: 400;
  line-height: 18px;
  white-space: pre-wrap;
  overflow-wrap: break-word;
}

.user-message .Message-Content {
  background-color: #f1f3f5;
  border-radius: 0px 16px 16px 16px;
  font-size: 14px;
  font-style: normal;
  font-weight: 400;
  line-height: 18px;
  white-space: pre-wrap;
  overflow-wrap: break-word;
  color: #061522;
}

.ChatBar-Heading-Container {
  display: flex;
  align-items: center;
  margin-top: 33px;
  gap: 15px;
  padding-left: 24px;
}
.chats-text {
  color: #061522;

  font-size: 14px;
  font-style: normal;
  font-weight: 500;
  line-height: 18px;
  cursor: pointer;
  padding-bottom: 4px;
}
.Archive-text {
  color: #405261;

  font-size: 14px;
  font-style: normal;
  font-weight: 400;
  line-height: 18px;
  cursor: pointer;
  padding-bottom: 4px;
}
.ChatBar-SearchInput {
  margin-top: 16px;
  padding-right: 32px;
  padding-left: 24px;
}
.ChatUser-Main-Container {
  background-color: #fff;
  height: calc(100vh - 15em);
  overflow: auto;
  width: 99%;
  padding-top: 20px;
}

/* Virtualized chat list: only the inner react-window scrolls (avoid double scrollbars). */
.ChatUser-Main-Container.ChatUser-Main-Container--virtualized {
  overflow: hidden !important;
  padding-top: 0;
}
.ChatBar-Container01 {
  margin-top: 6px;
}
.ChatUser-Container {
  display: flex;
  padding: 16px 24px;
  cursor: pointer;
}
.ChatUser-ContainerActive {
  border-radius: 9px;
  background: #f7f8f9;
  margin: 0px 16px;
  padding: 16px;
  padding-left: 8px;
}
.end-session-active {
  border-radius: 9px;
  background: #f7f8f9;
  margin: 0px 16px;
  padding: 16px;
  opacity: 80%;
}
.end-session-active-title {
  color: #405261 !important;
}
.Chat-User-Main {
  display: flex;
  flex-direction: column;
  width: 90%;
  margin-left: 10px;
  gap: 7px;
}

.Chat-User00 {
  display: flex;
  align-items: center;
  justify-content: space-between;
}
.Chat-User02 {
  display: flex;
  justify-content: space-between;
  align-items: center;
}
.Chat-User03 {
  display: flex;
  align-items: center;
  gap: 5px;
}
.Chat-User-Kathryn {
  display: flex;
  align-items: center;
  gap: 8px;
}
.ChatUser-text {
  color: #061522;
  font-size: 14px;
  font-style: normal;
  font-weight: 500;
  line-height: 18px;
  max-width: 115px;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.ChatUser-time {
  color: #405261;
  text-align: right;

  font-size: 12px;
  font-style: normal;
  font-weight: 400;
  line-height: 18px;
}
.ChatUser-discreption {
  color: #405261;

  font-size: 14px;
  font-style: normal;
  font-weight: 400;
  line-height: 18px;
  white-space: nowrap;
  width: 240px;
  overflow: hidden;
  text-overflow: ellipsis;
}
.Typing {
  color: #389e0d;
  font-size: 14px;
  font-style: normal;
  font-weight: 500;
  line-height: 18px;
}

.ActiveUser-Max {
  color: #405261;

  font-size: 12px;
  font-style: normal;
  font-weight: 400;
  line-height: 12px; /* 100% */
}
.ChatHeader-Main-Container {
  display: flex;
  border-bottom: 1px solid #e5e9ec;

  position: sticky;
  top: 0;
  opacity: 60;
  opacity: 60;

  /* Above message-area layers (e.g. time tooltips z-index: 10) so header is not covered */
  z-index: 50;

  /* 👇 semi-transparent instead of solid */
  /* 👇 semi-transparent instead of solid */
  background: rgba(255, 255, 255, 0.4);
  backdrop-filter: blur(15px);
  -webkit-backdrop-filter: blur(15px); /* Safari support */
  box-sizing: border-box;
}

.ChatHeader-Container {
  width: 100%;

  padding: 7px 24px;
  background: rgba(255, 255, 255, 0.4);
  backdrop-filter: blur(15px);
  align-items: center;
}
.ChatHeader-Logo-Container {
  display: flex;
  align-items: center;
  gap: 24px;
  /* margin-top: 20px; */
  position: relative;
}
.ChatHeader-Logo-Container p {
  position: relative;
  cursor: pointer;
}
.ChatHeader-Text {
  color: #061522;

  font-size: 24px;
  font-style: normal;
  font-weight: 500;
  line-height: 20px;
}

@media screen and (max-width: 1440px) {
  .ChatHeader-Text {
    color: #061522;
    font-size: 24px;
    font-style: normal;
    font-weight: 500;
    line-height: 20px;
    max-width: 300px;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
  }
}
.ChatHeader-ClockContainer {
  display: flex;
  /* margin-top: 18px; */
  gap: 10px;
}
.line {
  width: 1px;
  height: 16px;
  background: #e5e9ec;
}
.ChatHeaderTxt {
  color: #405261;

  font-size: 12px;
  font-style: normal;
  font-weight: 400;
  line-height: 12px; /* 100% */
  min-width: 124px;
  margin-top: 2px;
  margin-left: -4px;
}

.ChatMessage-Container {
  /* height: 100%; */
  position: relative;
  z-index: 0;
}
.ChatMessageComponent-Container {
  width: 100%;
  height: 100%;
  position: relative;
  display: flex;
  flex-direction: column;
  overflow: hidden;
}

.ChatMessageComponent-Container-Ticket {
  width: 100%;
  height: 100%;
  position: relative;
  display: flex;
  flex-direction: column;
  overflow: hidden;
}
.MessageComponet-Main {
  position: relative;
  flex: 1;
  min-height: 0;
  overflow: hidden;
  display: flex;
  flex-direction: column;
}
.MessageComponent-Main-02 {
  overflow-y: auto;
  height: calc(100vh - 22em);
  -webkit-box-flex: 1;
  /* flex-grow: 1; */
  overscroll-behavior-y: contain;
  padding: 25px;
  padding-bottom: 0px;
}
.TicketMessageComponent-Main-02 {
  flex: 1;
  min-height: 0;
  padding: 24px;
  padding-bottom: 0;
  overscroll-behavior-y: contain;
  overflow: hidden;
  position: relative;
}

.TicketMessageComponent-Main-02 .scroll-wrapper {
  height: 100%;
  overflow-y: auto;
  overflow-x: hidden;
  padding-right: 8px;
}

.TicketMessageComponent-Main-02 .scroll-wrapper::-webkit-scrollbar {
  width: 6px;
}

.TicketMessageComponent-Main-02 .scroll-wrapper::-webkit-scrollbar-track {
  background: transparent;
}

.ChatMessage_Container_Input {
  display: flex;
  flex-shrink: 0;
  padding: 0.75rem;
  padding-left: 24px;
  padding-right: 24px;
}
.ChatMessageInput-Main-Container {
  width: 100%;
  border-radius: 8px;
  border: 1px solid #d5dce1;
  background: #fff;
  box-shadow: 0px 1px 2px 0px rgba(6, 21, 34, 0.05);
  /* height: 136px; */
  padding: 12px 24px 24px;
}
.clearImg {
  cursor: pointer;
  position: absolute;
}
.ChatInput {
  border: none;
  width: 100%;

  font-family: "Inter", sans-serif;
  min-height: 46px;
  height: auto;
  outline: none;
  padding-top: 6px;
  resize: none;
  overflow: hidden;
  font-size: 16px;
}

.ChatInput::placeholder {
  color: #c5ced6;

  font-size: 16px;
  font-style: normal;
  font-weight: 400;
  line-height: 18px; /* 112.5% */
}

.ChatMessage-Button-Container {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-top: 10px;
}
.ChatMessage-Emoji00 {
  display: flex;
  align-items: center;
  gap: 16px;
}
.ChatMessage-Emoji00 p {
  cursor: pointer;
}
.Archive-Info {
  position: relative;
  bottom: -1rem;
  width: -webkit-fill-available;
}
.Archive-Section {
  display: flex;
  justify-content: space-between;
  border: 1px solid #d5dce1;
  align-items: center;
  height: 88px;
  padding: 0 20px;
  border-radius: 8px;
  margin: 0px 24px;
  margin-bottom: 20px;
  width: -webkit-fill-available;
  margin-top: 60px;
}
.ChatArchived-Hr {
  border: none;
  border-top: 1px solid #ccc;
  margin: 30px 0;
}
.Archive-msg {
  color: #061522;
}
.OpenChat-Button {
  margin-top: 15px;
  border-radius: 5px;
  background: #148dfd;
  box-shadow: 0px 1px 2px 0px rgba(6, 21, 34, 0.05);
  padding: 11px 36px;
  border: none;
  color: #fff;

  font-size: 14px;
  font-style: normal;
  font-weight: 500;
  cursor: pointer;
  line-height: 18px;
}
.StartChat-Button {
  margin-top: 15px;
  border-radius: 5px;
  background: #148dfd;
  box-shadow: 0px 1px 2px 0px rgba(6, 21, 34, 0.05);
  padding: 11px 36px;
  border: none;
  color: #fff;

  font-size: 14px;
  font-style: normal;
  font-weight: 500;
  cursor: pointer;
  line-height: 18px;
}
.ChatInput-Button {
  border-radius: 5px;
  background: #148dfd;
  box-shadow: 0px 1px 2px 0px rgba(6, 21, 34, 0.05);
  padding: 11px 36px;
  border: none;
  color: #fff;

  font-size: 14px;
  font-style: normal;
  font-weight: 500;
  cursor: pointer;
  line-height: 18px;
}
.ChatInput-Button:not(:disabled):hover {
  background-color: #0077cc;

  outline: none;
}
.ChatMessage-Footer-Container {
  padding-bottom: 37px;
}
/* Align Tags: with Archive-Section left edge (margin: 0 24px) */
.ChatMessage-Footer-Container--archive {
  margin: 0 24px;
  padding-bottom: 37px;
}
.ChatMessage-Footer-Container--archive .ChatMessage-Footer {
  padding: 0;
}
.ChatMessage-Footer {
  padding: 0px 24px;
}

.ChatMessage-Footer01 {
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: space-between;
}
.Message-Time-Header-Comment {
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 13px;
  width: 100%;
  margin-top: 0.75rem;
  margin-bottom: 29px;
}
.Message-Time-Header {
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 10px;
  width: 100%;
  margin-top: 0.75rem;
}
.Message-Time-Header-Ended {
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 10px;
  width: 100%;
  margin-top: 0.75rem;
  margin-bottom: 29px;
}
.Left-Chat-Container {
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 8px;
  padding-bottom: 32px;
}
.ant-switch .ant-switch-handle {
  width: 16px !important;
  height: 16px !important;
}
.Left-Chat-Text {
  color: #061522;
  font-size: 14px;
  font-style: normal;
  font-weight: 400;
  line-height: 12px;
}
.Chat-Comment-Container {
  text-align: center;
  padding-bottom: 32px;
}
.Chat-Comment {
  color: #061522;
  font-size: 14px;
  font-style: normal;
  font-weight: 400;
  line-height: 12px;
  padding-bottom: 16px;
}
.Chat-Comment-Text {
  color: #405261;
  font-size: 14px;
  font-weight: 400;
  line-height: 12px;
  font-style: italic;
}
.Message-Time-Text {
  color: #405261;
  text-align: center;
  font-size: 12px;
  font-style: normal;
  font-weight: 400;
  line-height: 12px;
}
.Left-Line {
  flex: 1;
  height: 1px;
  background: #f1f3f5;
}
.right-Line {
  flex: 1;
  height: 1px;
  background: #f1f3f5;
}

@media screen and (max-width: 1600px) {
  .Left-Line {
    height: 1px;
    background: #f1f3f5;
  }
  .right-Line {
    width: 35%;
    height: 1px;
    background: #f1f3f5;
  }
}
.ChatMessage-Footer-div01 {
  display: flex;
  align-items: center;
  gap: 6px;
}
.ChatMessage-Footer-div01 p {
  cursor: pointer;
}
.ChatFooter-text {
  color: #405261;

  font-size: 12px;
  font-style: normal;
  font-weight: 400;
  line-height: 12px; /* 100% */
}
.privateMode-Container {
  display: flex;
  align-items: center;
  gap: 6px;
}
.privateMode-text {
  color: #061522;
  text-align: right;

  font-size: 12px;
  font-style: normal;
  font-weight: 500;
  line-height: 14px; /* 116.667% */
}
.Message-User-Container-left {
  display: flex;
  flex-direction: row;
  width: 100%;
  justify-content: flex-start;
  align-self: flex-start;
  gap: 8px;
  margin: 10px 0px;
}
.Message-User-Container-box {
  padding: 15px;
  border-radius: 1px 16px 16px 16px;
  background: #f1f3f5;
  cursor: pointer;
  max-width: 50%;
}
.Message-User-Container-right {
  margin-top: 12px;
  display: flex;
  flex-direction: row-reverse;
  align-items: flex-end;
  align-self: flex-end;
  width: 100%;
  gap: 8px;
}
.Message-User-Message-Right001 {
  border-radius: 16px 16px 0px 16px;
  background: #148dfd;
  padding: 15px;
  max-width: 50%;
  flex-wrap: wrap;
  display: flex;
}

.rightuser-time {
  display: flex;
  justify-content: flex-end;
  align-items: end;
}
.User-Message-rightSide {
  color: #fff;

  font-size: 14px;
  font-style: normal;
  font-weight: 400;
  line-height: 18px;
  white-space: pre-wrap;
  word-break: break-word;
  overflow-wrap: break-word;
}

.First-Message-Heading {
  background-color: #f1f3f5;
  border-radius: 0 16px 0 0;
  font-size: 14px;
  font-weight: 500;
  padding: 0 0 0 14px;
}

.First-Message-Content {
  min-width: 300px;
  background-color: #ffffff;
  border-radius: 0 0 16px 16px;
  border: 14px solid #f1f3f5;
  padding: 16px;
}

.First-Message-Text {
  font-size: 14px;
  color: #061522;
}
.Message-Text {
  padding-top: 0px;
}
.highlight {
  color: #405261;
  font-size: 12px;
  font-weight: 400;
}

.User-message-text {
  text-align: left;
  color: #fff;
  font-size: 14px;
  font-style: normal;
  font-weight: 400;
  line-height: 18px;
  white-space: pre-wrap;
  overflow-wrap: break-word;
}

.User-message-text-down {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 8px;
}
.User-messagetext01 {
  color: #061522;

  font-size: 12px;
  font-style: normal;
  font-weight: 400;
  line-height: 12px; /* 100% */
}
.User-Messagetime01 {
  color: #556575;
  text-align: right;

  font-size: 12px;
  font-style: normal;
  font-weight: 400;
  line-height: 12px; /* 100% */
}
.User-Messagetime02 {
  color: #556575;
  text-align: right;

  font-size: 12px;
  font-style: normal;
  font-weight: 400;
  line-height: 12px; /* 100% */
  margin-top: 10px;
}
.dropdown-chat-menu {
  position: absolute;
  top: calc(100% + 5px);
  right: 0;
  width: 176px;
  box-sizing: border-box;
  border-radius: 8px;
  border: 1px solid #d5dce1;
  background: #fff;
  box-shadow: 0 15px 20px 0 rgba(6, 21, 34, 0.05);
  padding: 0;
  z-index: 9999;
}
.dropdown-chat-menu:hover {
  background: #fff;
}
.dropdown-chat-menu ul {
  list-style-type: none;
  padding: 0;
  margin: 0;
}
.dropdown-chat-menu ul li {
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 10px 16px;
  min-height: 0;
  cursor: pointer;
  color: #061522;
  font-family: "Inter", sans-serif;
  font-size: 14px;
  font-style: normal;
  font-weight: 400;
  line-height: 18px;
}
.dropdown-chat-menu ul:hover {
  background: #fff;
}
.dropdown-chat-menu ul .stop-chat-text {
  color: #e53935;
}
.dropdown-chat-menu ul li:hover {
  background-color: rgba(6, 21, 34, 0.04);
  border-radius: 0;
  color: #061522;
}
.dropdown-chat-menu ul .stop-chat-text:hover {
  background-color: rgba(229, 57, 53, 0.06);
  color: #e53935;
}
.Ticket-Button-Container {
  display: flex;
  gap: 8px;
  margin-top: 16px;
}
.logout-button-container {
  display: flex;
  gap: 8px;
}
.buttonstyle-Cancel {
  margin: auto;
  width: 49%;
  height: 40px;
  flex-shrink: 0;
  border-radius: 8px;
  border: 1px solid #d5dce1;
  background: #fff;
  box-shadow: 0px 1px 2px 0px rgba(6, 21, 34, 0.05);
  color: #405261;

  font-size: 14px;
  font-style: normal;
  font-weight: 500;
  line-height: 18px;
  cursor: pointer;
}
.buttonstyle-Cancel:not(:disabled):hover {
  background-color: #ffffff;
  border-color: #c5ced6;

  outline: none;
}
.buttonstyle-Ticket {
  margin: auto;
  width: 49%;
  height: 40px;
  flex-shrink: 0;
  border-radius: 8px;
  border: 1px solid #d5dce1;
  background: #148dfd;
  box-shadow: 0px 1px 2px 0px rgba(6, 21, 34, 0.05);
  border: none;
  color: #fff;

  font-size: 14px;
  font-style: normal;
  font-weight: 500;
  line-height: 18px;
  cursor: pointer;
}
.buttonstyle-Ticket:not(:disabled):hover {
  background-color: #0077cc;
}

.buttonstyle-Ticket:disabled {
  background: #f9fafa;
  color: #93a1b0;
  border: 1px solid #c5ced6;
  cursor: not-allowed;
}
.activeChat {
  display: inline-block; /* 👈 important */
  color: #061522;
  font-size: 14px;
  font-style: normal;
  font-weight: 500;
  line-height: 18px;
  border-bottom: 1px solid #148dfd;
  cursor: pointer;
}

.check__box__chat {
  display: flex;
  margin-top: 14px;
}
.block__check__chat {
  align-items: center;
}

.custom-checkbox__chat {
  display: none;
}
.onlineStatus {
  width: 8px;
  height: 8px;
  top: 275px;
  left: 144px;
  gap: 0px;
  opacity: 0px;
  background-color: #389e0d;
  border-radius: 20px;
}
.offlineStatus {
  width: 8px;
  height: 8px;
  top: 275px;
  left: 144px;
  gap: 0px;
  opacity: 0px;
  background-color: #93a1b0;
  border-radius: 20px;
}
.custom-checkbox__chat + label {
  position: relative;
  padding-left: 20px;
  cursor: pointer;
  align-items: center;
  bottom: 4px;
}

.custom-checkbox__chat + label::before {
  content: "";
  position: absolute;
  left: 0;
  top: 0;
  width: 18px;
  height: 18px;
  border-radius: 4px;
  border: 1px solid #d5dce1;
  background: #fff;
  box-shadow: 0px 1px 2px 0px rgba(20, 141, 253, 0.1);
}

.custom-checkbox__chat + label::after {
  content: "✔";
  position: absolute;
  left: 0px;
  top: 0.5px;
  text-align: center;
  color: #148dfd;
  stroke-width: 1px;
  border-radius: 4px;
  border: 1px solid #148dfd;
  width: 18px;
  height: 18px;
  opacity: 0; /* Initially hidden */

  flex-shrink: 0;
}

.custom-checkbox__chat:checked + label::after {
  opacity: 1;
}

.Remember__01_chat {
  color: #405261;

  font-size: 14px;
  font-style: normal;
  font-weight: 400;
  line-height: 20px; /* 142.857% */
  margin-left: 8px;
}
.ChatAgent-Main-Container {
  display: flex;
  gap: 30px;
  margin-top: 22px;
  margin-bottom: 14px;
}
.ChatAgent-Main-Container-Assign {
  display: flex;
}
.SearchChat-Popup-Assign {
  margin-top: 14px;
  margin-bottom: 22px;
}
.SearchChat-Popup-Feedback {
  margin-top: 16px;

  margin-bottom: 16px;
}
.SearchInputField-FeedBack {
  height: 40px;
}
.SearchInputField-kb {
  height: 60px;
}
.SearchInputField-kb-layout {
  height: 60px;
  min-width: 430px;
}

@media (max-width: 601px) {
  .SearchInputField-kb-layout {
    min-width: unset;
    min-width: 150px;
    height: 40px;
  }
}
@media (max-width: 900px) {
  .SearchInputField-kb-layout {
    min-width: unset;
    min-width: 220px;
    height: 40px;
  }
}
.SearchChat-Popup {
  margin-top: 8px;
  margin-bottom: 22px;
}
.Assign-PopUp-Container {
  border-radius: 8px;
  border: 1px solid #d5dce1;
  background: #fff;
  box-shadow: 0px 15px 20px 0px rgba(6, 21, 34, 0.05);
  padding: 32px;
  max-width: 424px;

  height: auto;
  z-index: 1;
  right: 0;
  left: 0;
  position: absolute;
  margin: 0 auto;
  top: 15%;
}
.AgentsList {
  padding: 0 2px;
}
.ChatPopup-Darleen-Container:hover {
  background-color: #f9fafa;
  border-radius: 8px;
}
.ChatPopup-Darleen-Container {
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 8px;
  cursor: pointer;
  border: 1px solid transparent;
}
.ChatPopup-Darleen-Container.selected {
  border-radius: 8px;
  background: #f3fbff;
  border: 1px solid #148dfd;
}
.AddTansfer:disabled {
  background: #f9fafa;
  color: #93a1b0;
  border: 1px solid #c5ced6;
  cursor: not-allowed;
}
.Albert-text {
  color: #061522;

  font-size: 14px;
  font-style: normal;
  font-weight: 500;
  line-height: 18px;
}
.No-activetext {
  color: #556575;

  font-size: 14px;
  font-style: normal;
  font-weight: 400;
  line-height: 18px;
}
.AssignChat-footer {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-top: 30px;
}
.AssignTicket-footer {
  margin-top: 30px;
}
.Add-PrivateChat {
  color: #061522;

  font-size: 14px;
  font-style: normal;
  font-weight: 500;
  line-height: 18px;
}
.cancel-btn {
  background: transparent;
  border: 1px solid #d5dce1;

  padding: 8px 16px;
  border-radius: 8px;
  cursor: pointer;
  color: #061522;
  height: 40px;
  font-size: 14px;
  font-style: normal;
  font-weight: 500;
  line-height: 18px;
  width: 100%;
  transition: all 0.2s ease;
}

.cancel-btn:not(:disabled):hover {
  border: 1px solid #c5ced6;
  background-color: #fff;
}
.AddTansfer {
  border-radius: 8px;
  background: #148dfd;
  box-shadow: 0px 1px 2px 0px rgba(6, 21, 34, 0.05);
  border: none;
  color: #fff;
  text-align: center;
  float: right;
  font-size: 14px;
  font-style: normal;
  font-weight: 500;
  line-height: 18px;
  padding: 11px 17px;
  cursor: pointer;
  width: 112px;
}
.AddTansfer:not(:disabled):hover {
  background-color: #0077cc;

  outline: none;
}
.chat-txt {
  font-size: 12px;
  color: #405261;
  margin: 10px 0;
}

.thumbnail-image {
  width: 98px;
  height: 98px;
  border-radius: 8px;
}
.Canned-PopUp-Container {
  border-radius: 8px;
  border: 1px solid #d5dce1;
  background: #fff;
  box-shadow: 0px 15px 20px 0px rgba(6, 21, 34, 0.05);
  padding: 30px;
  width: 424px;
  max-height: 440px;
  z-index: 1000;
  position: fixed;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
}

.Canned-PopUp-Container01 {
  border-radius: 8px;
  border: 1px solid #d5dce1;
  background: #fff;
  box-shadow: 0px 15px 20px 0px rgba(6, 21, 34, 0.05);
  padding: 30px;
  width: 424px;
  max-height: 440px;
  z-index: 1000;
  position: fixed;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
}
.modal {
  display: flex;
  justify-content: center;
  align-items: center;
  position: fixed;
  z-index: 1000;
  left: 0;
  top: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.9);
}
.modal-close {
  position: absolute;
  top: 20px;
  right: 35px;
  color: white;
  font-size: 30px;
  cursor: pointer;
}
.modal-image {
  max-width: 100%;
  max-height: 100%;
}
.dropdown-canned-tag {
  max-height: 400px;
  position: absolute;
  bottom: 100px;
  width: 256px;

  border-radius: 8px;
  border: 1px solid #d5dce1;
  background: #fff;
  box-shadow: 0px 15px 20px 0px rgba(6, 21, 34, 0.05);
  padding: 8px 11px;
  z-index: 1;
}
.dropdown-canned-tag-list {
  max-height: 309px;
  overflow-y: auto;
  overflow-x: hidden;
  box-sizing: border-box;
}
.dropdown-canned-msg-list {
  max-height: 345px;
  overflow-y: auto;
  overflow-x: hidden;
  box-sizing: border-box;
}
.dropdown-canned-tag:hover {
  background: #fff;
}

.dropdown-canned-tag ul {
  list-style-type: none;
  padding: 0;
  margin: 0;
}

.dropdown-canned-tag ul li {
  padding: 9px 10px;
  cursor: pointer;
  color: #405261;

  font-size: 14px;
  font-style: normal;
  font-weight: 400;
  line-height: normal;

  word-break: break-word;
  overflow-wrap: break-word;
  white-space: normal;
  transition: background-color 0.3s;
}

.dropdown-canned-tag ul:hover {
  background: #fff;
}

.dropdown-canned-tag ul li:hover {
  background-color: #f5f5f5;
  border-radius: 8px;
  background: #f9fafa;
}
.button-container-tag {
  position: relative;
  justify-content: space-between;
  display: flex;
  align-items: center;
  padding: 6px;
  background: #fff;
  cursor: default;
}
.dropdown-chat-tag {
  position: absolute;
  right: 0%;
  width: 232px;
  /* top: 50px; */
  left: 20%;
  bottom: 30px;
  border-radius: 8px;
  border: 1px solid #d5dce1;
  background: #fff;
  box-shadow: 0px 15px 20px 0px rgba(6, 21, 34, 0.05);
  padding: 8px 11px;
  z-index: 1;
}
.input-container-tag {
  position: relative;
  display: flex;
  align-items: center;
  border-radius: 8px;
  border: 1px solid #d5dce1;
  background: #fff;
  box-shadow: 0px 1px 2px 0px rgba(6, 21, 34, 0.05);
  padding: 13px;
}

.input-icon-left,
.input-icon-right {
  position: absolute;
  top: 55%;
  transform: translateY(-50%);
}
.TagInput {
  border: none;
  outline: none;
  width: 100%;
  padding-left: 20px;
}
.input-icon-left {
  left: 8px;
}
.input-icon-right {
  right: 8px;
}
.dropdown-chat-tag:hover {
  background: #fff;
}
.dropdown-chat-tag ul {
  list-style-type: none;
  padding: 0;
  margin: 0;
}
.dropdown-chat-tag ul li {
  display: flex;
  gap: 8px;
  padding: 9px 10px;
  cursor: pointer;
  color: #405261;

  font-size: 14px;
  font-style: normal;
  font-weight: 400;
  line-height: normal;
}
.dropdown-chat-tag ul:hover {
  background: #fff;
}
.dropdown-chat-tag ul li:hover {
  background-color: #f5f5f5;
  border-radius: 8px;
  background: #f9fafa;
}
.ChatSideBar-Main-Container {
  width: 26em;
  height: 100%;
  overflow: hidden;
  transition: transform 0.3s ease;
  border-left: 1px solid #e5e9ec;
}

.Chat-SideBar-Heading {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 24px;
}
.SideBar-details {
  color: #061522;

  font-size: 24px;
  font-style: normal;
  font-weight: 500;
  line-height: 18px; /* 75% */
}
.ChatSideBar-Profile {
  display: flex;
  justify-content: space-between;
  align-items: center;
}
.ChatSideBar-profile-cotnainer {
  display: flex;
  align-items: center;
  gap: 8px;
  position: relative;
}
.ChatSideBar-CutomerDetails {
  margin-bottom: 30px;
}
.ChatSideBar-Content-Container {
  padding: 0 24px;
  max-height: calc(100vh - 400px);
  overflow-y: auto;
  margin-bottom: 10px;
  margin-top: 16px;
}
.Kriti-Watson {
  color: #061522;

  font-size: 16px;
  font-style: normal;
  font-weight: 500;
  line-height: 18px;
}

@media screen and (max-width: 1600px) {
  .Kriti-Watson {
    color: #061522;
    font-size: 16px;
    font-style: normal;
    font-weight: 500;
    line-height: 18px;
    max-width: 225px;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
  }
}
.nathan-johnes {
  color: #405261;

  font-size: 14px;
  font-style: normal;
  font-weight: 400;
  line-height: 18px;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  max-width: 140px;
}

.ChatSideBar-ClientButton {
  border-radius: 5px;
  border: 1px solid #d5dce1;
  background: #fff;
  box-shadow: 0px 1px 2px 0px rgba(6, 21, 34, 0.05);
  color: #405261;

  font-size: 12px;
  font-style: normal;
  font-weight: 400;
  line-height: 18px; /* 150% */
  padding: 3px 16px;
}

.Sidebar-bottomLine {
  border-bottom: 1px solid #e5e9ec;
  background: #fff;
  margin: 16px 0px;
}
.ChatSideBar-Container-customer {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  padding: 12px 0px;
}

.ChatSidear-customer {
  display: flex;
  align-items: center;
  gap: 8px;
  width: 50%;
}
.sidebar-content01 {
  color: #061522;
  font-size: 16px;
  font-style: normal;
  font-weight: 400;
  line-height: 18px; /* 112.5% */
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  margin-left: 32px;
  max-width: 250px;
}

.sidebar-content01:hover {
  overflow: visible;
  white-space: wrap;
  background: #fff;
  z-index: 1;
}

.chatsidebar-content02 {
  color: #405261;
  font-size: 14px;
  font-style: normal;
  font-weight: 400;
  height: 24px;
  align-self: center;

  line-height: 18px;
}

.ChatSideBar-Footer-Container {
  border-radius: 8px;
  border: 1px solid #e5e9ec;
  background: #fff;
  padding: 24px;
}
.ChatSideBar-FooterHeading {
  display: flex;
  align-items: center;
  gap: 16px;
}
.visited-page01 {
  color: #061522;

  font-size: 18px;
  font-style: normal;
  font-weight: 500;
  line-height: 18px; /* 100% */
  border-right: 1px solid #061522;
  padding-right: 10px;
}
.viewedpage {
  color: #405261;
  text-align: right;

  font-size: 14px;
  font-style: normal;
  font-weight: 400;
  line-height: 18px;
}
.livechat-footer {
  display: flex;
  gap: 8px;
  margin-top: 22px;
}
.chat-sidefooter-user {
  color: #061522;

  font-size: 14px;
  font-style: normal;
  font-weight: 500;
  line-height: 18px;
}
.chat-sidefooter-user01 {
  color: #405261;

  font-size: 14px;
  font-style: normal;
  font-weight: 400;
  line-height: 18px;
}
.ChatUser-red {
  border-radius: 9px;
  background: #ff4d4f;
  padding: 0px 8px;
  color: #fff;
  text-align: center;

  font-size: 12px;
  font-style: normal;
  font-weight: 700;
  line-height: 18px;
  width: 29px;
}
.ScrollToTop-Main-Container {
  display: flex;
  position: absolute;
  gap: 6px;
  padding: 11px 25px;
  align-items: center;
  width: 259px;
  margin: 0 auto;
  left: 0;
  right: 0;
  height: 40px;
  border-radius: 8px;
  border: 1px solid #e5e9ec;
  background: rgba(255, 255, 255, 0.4);
  backdrop-filter: blur(15px);
  cursor: pointer;
}
.SCrollTop-Text {
  color: #405261;

  font-size: 14px;
  font-style: normal;
  font-weight: 400;
  line-height: 18px;
}

.ScrollToTop-Main-Container-Btm {
  display: flex;
  position: absolute;
  gap: 6px;
  padding: 11px 22px;
  align-items: center;
  width: 280px;
  margin: 0 auto;
  left: 0;
  right: 0;
  bottom: 10px;
  height: 40px;
  border-radius: 8px;
  border: 1px solid #e5e9ec;
  background: rgba(255, 255, 255, 0.4);
  backdrop-filter: blur(15px);
  cursor: pointer;
}
.SCrollTop-Text-Btm {
  color: #405261;

  font-size: 14px;
  font-style: normal;
  font-weight: 400;
  line-height: 18px;
}
.EmojiPicker-Top {
  position: absolute;
  bottom: 20%;
  left: 12px;
}

.PopUp-Canned-Text {
  color: #405261;

  font-size: 10px;
  font-style: normal;
  font-weight: 400;
  line-height: 18px; /* 180% */
}
.PopUp-Canned-footer {
  display: flex;
  justify-content: space-between;
  align-items: center;
}
.Canned-Advance-text {
  color: #061522;

  font-size: 14px;
  font-style: normal;
  font-weight: 500;
  line-height: 18px; /* 128.571% */
}
.PopUpCanned-button {
  display: flex;
  align-items: center;
  gap: 8px;
}
.Canned-Cancel {
  border-radius: 8px;
  border: 1px solid #d5dce1;
  background: #fff;
  box-shadow: 0px 1px 2px 0px rgba(6, 21, 34, 0.05);
  padding: 10px 24px;
  color: #405261;
  text-align: center;

  font-size: 14px;
  font-style: normal;
  font-weight: 500;
  line-height: 18px;
  cursor: pointer;
}
.Canned-Cancel:hover:not(:disabled) {
  border-radius: 8px;
  border: 1px solid #c5ced6;
  background: #fff;
  box-shadow: 0 1px 2px 0 rgba(6, 21, 34, 0.05);
}
.Canned-Save {
  border-radius: 8px;
  background: #148dfd;
  box-shadow: 0px 1px 2px 0px rgba(6, 21, 34, 0.05);
  border: none;
  padding: 11px 32px;
  color: #fff;
  text-align: center;

  font-size: 14px;
  font-style: normal;
  font-weight: 500;
  line-height: 18px;
  cursor: pointer;
}
.Canned-Save:disabled {
  border-radius: 8px;
  border: 1px solid #c5ced6;
  background: #f9fafa;
  color: #93a1b0;
  box-shadow: 0 1px 2px 0 rgba(6, 21, 34, 0.05);
  cursor: not-allowed;
}
.Canned-Save:hover:not(:disabled) {
  background: #0077cc;
}
.Caneed-responseInput-Container {
  margin: 20px 0px 30px;
}

.LoaderMenu-Container {
  border-radius: 8px;
  border: 1px solid #d5dce1;
  background: #fff;
  box-shadow: 0px 15px 20px 0px rgba(6, 21, 34, 0.05);
  padding: 16px;
}
.ChatMenu-Container {
  display: flex;
  gap: 8px;
}
.Chat-MessageMenu-Container {
  position: relative;
  right: 2%;
  display: flex;
  align-items: center;
}
.chatbubble-text {
  color: #405261;

  font-size: 14px;
  font-style: normal;
  font-weight: 400;
  line-height: normal;
}
.chatbubble-textdelete {
  color: #ff4d4f;

  font-size: 14px;
  font-style: normal;
  font-weight: 400;
  line-height: normal;
}
.typing-indicator {
  /* position: absolute;
  bottom: 0; */
  color: #888;
  background-color: #fff;
  font-size: 14px;
  width: 100%;
}
@media screen and (min-width: 1600px) {
  .ChatSideBar-Main-Container {
    width: 26em;
  }
  .nathan-johnes {
    max-width: 300px;
  }
  .sidebar-content01 {
    max-width: 350px;
  }
  .nathan-johnes:hover {
    background: none;
    z-index: 0;
    position: relative;
    top: 0;
    left: 0;
    width: 100%;
    max-width: 100%;
  }
  .ChatSideBar-Content-Container {
    padding-right: 32px;
  }
}
.private-message .Private-Message-Content {
  background: #fff7e6;
  color: #061522;
  border-radius: 16px 16px 0px 16px;
  font-size: 14px;
  font-style: normal;
  font-weight: 400;
  line-height: 18px;
  white-space: pre-wrap;
  overflow-wrap: break-word;
}
.private-message {
  background: #fff7e6;
  color: #061522;
}
.ChatSidear-customer p {
  margin: 0; /* Remove default paragraph margin */
  display: flex;
  align-items: center; /* Ensure icon inside also centers */
}
.custom-time-tooltip-wrapper {
  position: relative;
  display: inline-block;
}
/* Portaled to <body> so the thread's clipping/stacking contexts cannot cut it off.
   Position comes from CustomTimeTooltip.js. */
.custom-time-tooltip {
  position: fixed;
  min-width: 94px;
  height: 33.899px;
  padding: 0 10px;
  box-sizing: border-box;
  background: #061522;
  color: #fff;
  text-align: center;
  font-family:
    "Apercu Pro", "Apercu Mono Pro Medium", "Apercu Mono Pro Bold", Arial,
    sans-serif;
  font-size: 12px;
  font-style: normal;
  font-weight: 500;
  line-height: 12px;
  border-radius: 12px;
  box-shadow: 0px 4px 8px rgba(0, 0, 0, 0.06);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 1500;
  pointer-events: none;
}
.custom-time-tooltip::after {
  content: "";
  position: absolute;
  top: 100%;
  left: var(--tooltip-arrow-left, 50%);
  transform: translateX(-50%);
  border-width: 6px;
  border-style: solid;
  border-color: #061522 transparent transparent transparent;
}

/* Flipped under the bubble when there is no room above (avoids overlapping the chat header) */
.custom-time-tooltip.custom-time-tooltip--below::after {
  top: auto;
  bottom: 100%;
  border-color: transparent transparent #061522 transparent;
}
.typing-indicator-dots {
  display: flex;
  align-items: center;
  gap: 4px;
  height: 16px;
}
.typing-dot {
  width: 8px;
  height: 8px;
  border-radius: 50%;
  background-color: #148dfd;
  opacity: 0.7;
  animation: typing-bounce 1.2s infinite ease-in-out;
}
.typing-dot:nth-child(2) {
  animation-delay: 0.2s;
}
.typing-dot:nth-child(3) {
  animation-delay: 0.4s;
}
@keyframes typing-bounce {
  0%,
  80%,
  100% {
    transform: scale(0.8);
    opacity: 0.7;
  }
  40% {
    transform: scale(1.2);
    opacity: 1;
  }
}
`, "",{"version":3,"sources":["webpack://./src/components/dashboardcomponents/ChatComponents/style.css"],"names":[],"mappings":"AAAA;EACE,YAAY;EACZ,YAAY;EACZ,cAAc;EACd,+BAA+B;EAC/B,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,cAAc;AAChB;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,QAAQ;AACV;;AAEA;;EAEE,iBAAiB;AACnB;;AAEA;EACE,cAAc;EACd,eAAe;AACjB;AACA;EACE,cAAc;;EAEd,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,iBAAiB,EAAE,QAAQ;EAC3B,kBAAkB;AACpB;AACA;EACE,aAAa;EACb,2BAA2B;EAC3B,QAAQ;AACV;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,2BAA2B;AAC7B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,mBAAmB;EACnB,sBAAsB;EACtB,qBAAqB;AACvB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,iBAAiB;AACnB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,YAAY;EACZ,kBAAkB;AACpB;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,sBAAsB;EACtB,mBAAmB;EACnB,mBAAmB;EACnB,WAAW;EACX,aAAa;EACb,kBAAkB;EAClB,YAAY;EACZ,kBAAkB;AACpB;AACA;EACE,sBAAsB;EACtB,mBAAmB;EACnB,mBAAmB;EACnB,aAAa;EACb,kBAAkB;EAClB,kBAAkB;EAClB,YAAY;AACd;;AAEA;EACE,aAAa;EACb,gBAAgB;EAChB,yBAAyB;EACzB,iCAAiC;EACjC,WAAW;EACX,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,iBAAiB;EACjB,qBAAqB;EACrB,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;EACzB,iCAAiC;EACjC,WAAW;EACX,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,iBAAiB;EACjB,qBAAqB;EACrB,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;EACzB,iCAAiC;EACjC,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,iBAAiB;EACjB,qBAAqB;EACrB,yBAAyB;EACzB,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,gBAAgB;EAChB,SAAS;EACT,kBAAkB;AACpB;AACA;EACE,cAAc;;EAEd,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,iBAAiB;EACjB,eAAe;EACf,mBAAmB;AACrB;AACA;EACE,cAAc;;EAEd,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,iBAAiB;EACjB,eAAe;EACf,mBAAmB;AACrB;AACA;EACE,gBAAgB;EAChB,mBAAmB;EACnB,kBAAkB;AACpB;AACA;EACE,sBAAsB;EACtB,0BAA0B;EAC1B,cAAc;EACd,UAAU;EACV,iBAAiB;AACnB;;AAEA,0FAA0F;AAC1F;EACE,2BAA2B;EAC3B,cAAc;AAChB;AACA;EACE,eAAe;AACjB;AACA;EACE,aAAa;EACb,kBAAkB;EAClB,eAAe;AACjB;AACA;EACE,kBAAkB;EAClB,mBAAmB;EACnB,gBAAgB;EAChB,aAAa;EACb,iBAAiB;AACnB;AACA;EACE,kBAAkB;EAClB,mBAAmB;EACnB,gBAAgB;EAChB,aAAa;EACb,YAAY;AACd;AACA;EACE,yBAAyB;AAC3B;AACA;EACE,aAAa;EACb,sBAAsB;EACtB,UAAU;EACV,iBAAiB;EACjB,QAAQ;AACV;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;AAChC;AACA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;AACrB;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;AACV;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;AACV;AACA;EACE,cAAc;EACd,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,iBAAiB;EACjB,gBAAgB;EAChB,mBAAmB;EACnB,gBAAgB;EAChB,uBAAuB;AACzB;;AAEA;EACE,cAAc;EACd,iBAAiB;;EAEjB,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,iBAAiB;AACnB;AACA;EACE,cAAc;;EAEd,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,iBAAiB;EACjB,mBAAmB;EACnB,YAAY;EACZ,gBAAgB;EAChB,uBAAuB;AACzB;AACA;EACE,cAAc;EACd,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA;EACE,cAAc;;EAEd,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,iBAAiB,EAAE,SAAS;AAC9B;AACA;EACE,aAAa;EACb,gCAAgC;;EAEhC,gBAAgB;EAChB,MAAM;EACN,WAAW;EACX,WAAW;;EAEX,wFAAwF;EACxF,WAAW;;EAEX,yCAAyC;EACzC,yCAAyC;EACzC,oCAAoC;EACpC,2BAA2B;EAC3B,mCAAmC,EAAE,mBAAmB;EACxD,sBAAsB;AACxB;;AAEA;EACE,WAAW;;EAEX,iBAAiB;EACjB,oCAAoC;EACpC,2BAA2B;EAC3B,mBAAmB;AACrB;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,sBAAsB;EACtB,kBAAkB;AACpB;AACA;EACE,kBAAkB;EAClB,eAAe;AACjB;AACA;EACE,cAAc;;EAEd,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA;EACE;IACE,cAAc;IACd,eAAe;IACf,kBAAkB;IAClB,gBAAgB;IAChB,iBAAiB;IACjB,gBAAgB;IAChB,mBAAmB;IACnB,gBAAgB;IAChB,uBAAuB;EACzB;AACF;AACA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;AACA;EACE,UAAU;EACV,YAAY;EACZ,mBAAmB;AACrB;AACA;EACE,cAAc;;EAEd,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,iBAAiB,EAAE,SAAS;EAC5B,gBAAgB;EAChB,eAAe;EACf,iBAAiB;AACnB;;AAEA;EACE,kBAAkB;EAClB,kBAAkB;EAClB,UAAU;AACZ;AACA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,aAAa;EACb,sBAAsB;EACtB,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,aAAa;EACb,sBAAsB;EACtB,gBAAgB;AAClB;AACA;EACE,kBAAkB;EAClB,OAAO;EACP,aAAa;EACb,gBAAgB;EAChB,aAAa;EACb,sBAAsB;AACxB;AACA;EACE,gBAAgB;EAChB,0BAA0B;EAC1B,mBAAmB;EACnB,kBAAkB;EAClB,8BAA8B;EAC9B,aAAa;EACb,mBAAmB;AACrB;AACA;EACE,OAAO;EACP,aAAa;EACb,aAAa;EACb,iBAAiB;EACjB,8BAA8B;EAC9B,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,YAAY;EACZ,gBAAgB;EAChB,kBAAkB;EAClB,kBAAkB;AACpB;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,uBAAuB;AACzB;;AAEA;EACE,aAAa;EACb,cAAc;EACd,gBAAgB;EAChB,kBAAkB;EAClB,mBAAmB;AACrB;AACA;EACE,WAAW;EACX,kBAAkB;EAClB,yBAAyB;EACzB,gBAAgB;EAChB,iDAAiD;EACjD,mBAAmB;EACnB,uBAAuB;AACzB;AACA;EACE,eAAe;EACf,kBAAkB;AACpB;AACA;EACE,YAAY;EACZ,WAAW;;EAEX,gCAAgC;EAChC,gBAAgB;EAChB,YAAY;EACZ,aAAa;EACb,gBAAgB;EAChB,YAAY;EACZ,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,cAAc;;EAEd,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,iBAAiB,EAAE,WAAW;AAChC;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,gBAAgB;AAClB;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;AACX;AACA;EACE,eAAe;AACjB;AACA;EACE,kBAAkB;EAClB,aAAa;EACb,6BAA6B;AAC/B;AACA;EACE,aAAa;EACb,8BAA8B;EAC9B,yBAAyB;EACzB,mBAAmB;EACnB,YAAY;EACZ,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,mBAAmB;EACnB,6BAA6B;EAC7B,gBAAgB;AAClB;AACA;EACE,YAAY;EACZ,0BAA0B;EAC1B,cAAc;AAChB;AACA;EACE,cAAc;AAChB;AACA;EACE,gBAAgB;EAChB,kBAAkB;EAClB,mBAAmB;EACnB,iDAAiD;EACjD,kBAAkB;EAClB,YAAY;EACZ,WAAW;;EAEX,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;EACf,iBAAiB;AACnB;AACA;EACE,gBAAgB;EAChB,kBAAkB;EAClB,mBAAmB;EACnB,iDAAiD;EACjD,kBAAkB;EAClB,YAAY;EACZ,WAAW;;EAEX,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;EACf,iBAAiB;AACnB;AACA;EACE,kBAAkB;EAClB,mBAAmB;EACnB,iDAAiD;EACjD,kBAAkB;EAClB,YAAY;EACZ,WAAW;;EAEX,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;EACf,iBAAiB;AACnB;AACA;EACE,yBAAyB;;EAEzB,aAAa;AACf;AACA;EACE,oBAAoB;AACtB;AACA,gEAAgE;AAChE;EACE,cAAc;EACd,oBAAoB;AACtB;AACA;EACE,UAAU;AACZ;AACA;EACE,iBAAiB;AACnB;;AAEA;EACE,WAAW;EACX,aAAa;EACb,mBAAmB;EACnB,8BAA8B;AAChC;AACA;EACE,WAAW;EACX,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,SAAS;EACT,WAAW;EACX,mBAAmB;EACnB,mBAAmB;AACrB;AACA;EACE,WAAW;EACX,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,SAAS;EACT,WAAW;EACX,mBAAmB;AACrB;AACA;EACE,WAAW;EACX,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,SAAS;EACT,WAAW;EACX,mBAAmB;EACnB,mBAAmB;AACrB;AACA;EACE,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,QAAQ;EACR,oBAAoB;AACtB;AACA;EACE,sBAAsB;EACtB,uBAAuB;AACzB;AACA;EACE,cAAc;EACd,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,iBAAiB;AACnB;AACA;EACE,kBAAkB;EAClB,oBAAoB;AACtB;AACA;EACE,cAAc;EACd,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,iBAAiB;EACjB,oBAAoB;AACtB;AACA;EACE,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,iBAAiB;EACjB,kBAAkB;AACpB;AACA;EACE,cAAc;EACd,kBAAkB;EAClB,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,iBAAiB;AACnB;AACA;EACE,OAAO;EACP,WAAW;EACX,mBAAmB;AACrB;AACA;EACE,OAAO;EACP,WAAW;EACX,mBAAmB;AACrB;;AAEA;EACE;IACE,WAAW;IACX,mBAAmB;EACrB;EACA;IACE,UAAU;IACV,WAAW;IACX,mBAAmB;EACrB;AACF;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;AACV;AACA;EACE,eAAe;AACjB;AACA;EACE,cAAc;;EAEd,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,iBAAiB,EAAE,SAAS;AAC9B;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;AACV;AACA;EACE,cAAc;EACd,iBAAiB;;EAEjB,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,iBAAiB,EAAE,aAAa;AAClC;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,WAAW;EACX,2BAA2B;EAC3B,sBAAsB;EACtB,QAAQ;EACR,gBAAgB;AAClB;AACA;EACE,aAAa;EACb,iCAAiC;EACjC,mBAAmB;EACnB,eAAe;EACf,cAAc;AAChB;AACA;EACE,gBAAgB;EAChB,aAAa;EACb,2BAA2B;EAC3B,qBAAqB;EACrB,oBAAoB;EACpB,WAAW;EACX,QAAQ;AACV;AACA;EACE,iCAAiC;EACjC,mBAAmB;EACnB,aAAa;EACb,cAAc;EACd,eAAe;EACf,aAAa;AACf;;AAEA;EACE,aAAa;EACb,yBAAyB;EACzB,gBAAgB;AAClB;AACA;EACE,WAAW;;EAEX,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,iBAAiB;EACjB,qBAAqB;EACrB,sBAAsB;EACtB,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;EACzB,yBAAyB;EACzB,eAAe;EACf,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;EAChB,yBAAyB;EACzB,4BAA4B;EAC5B,0BAA0B;EAC1B,aAAa;AACf;;AAEA;EACE,eAAe;EACf,cAAc;AAChB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,cAAc;EACd,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,WAAW;EACX,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,iBAAiB;EACjB,qBAAqB;EACrB,yBAAyB;AAC3B;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,QAAQ;AACV;AACA;EACE,cAAc;;EAEd,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,iBAAiB,EAAE,SAAS;AAC9B;AACA;EACE,cAAc;EACd,iBAAiB;;EAEjB,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,iBAAiB,EAAE,SAAS;AAC9B;AACA;EACE,cAAc;EACd,iBAAiB;;EAEjB,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,iBAAiB,EAAE,SAAS;EAC5B,gBAAgB;AAClB;AACA;EACE,kBAAkB;EAClB,qBAAqB;EACrB,QAAQ;EACR,YAAY;EACZ,sBAAsB;EACtB,kBAAkB;EAClB,yBAAyB;EACzB,gBAAgB;EAChB,+CAA+C;EAC/C,UAAU;EACV,aAAa;AACf;AACA;EACE,gBAAgB;AAClB;AACA;EACE,qBAAqB;EACrB,UAAU;EACV,SAAS;AACX;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,kBAAkB;EAClB,aAAa;EACb,eAAe;EACf,cAAc;EACd,gCAAgC;EAChC,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,iBAAiB;AACnB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,cAAc;AAChB;AACA;EACE,uCAAuC;EACvC,gBAAgB;EAChB,cAAc;AAChB;AACA;EACE,yCAAyC;EACzC,cAAc;AAChB;AACA;EACE,aAAa;EACb,QAAQ;EACR,gBAAgB;AAClB;AACA;EACE,aAAa;EACb,QAAQ;AACV;AACA;EACE,YAAY;EACZ,UAAU;EACV,YAAY;EACZ,cAAc;EACd,kBAAkB;EAClB,yBAAyB;EACzB,gBAAgB;EAChB,iDAAiD;EACjD,cAAc;;EAEd,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,iBAAiB;EACjB,eAAe;AACjB;AACA;EACE,yBAAyB;EACzB,qBAAqB;;EAErB,aAAa;AACf;AACA;EACE,YAAY;EACZ,UAAU;EACV,YAAY;EACZ,cAAc;EACd,kBAAkB;EAClB,yBAAyB;EACzB,mBAAmB;EACnB,iDAAiD;EACjD,YAAY;EACZ,WAAW;;EAEX,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,iBAAiB;EACjB,eAAe;AACjB;AACA;EACE,yBAAyB;AAC3B;;AAEA;EACE,mBAAmB;EACnB,cAAc;EACd,yBAAyB;EACzB,mBAAmB;AACrB;AACA;EACE,qBAAqB,EAAE,iBAAiB;EACxC,cAAc;EACd,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,iBAAiB;EACjB,gCAAgC;EAChC,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,gBAAgB;AAClB;AACA;EACE,mBAAmB;AACrB;;AAEA;EACE,aAAa;AACf;AACA;EACE,UAAU;EACV,WAAW;EACX,UAAU;EACV,WAAW;EACX,QAAQ;EACR,YAAY;EACZ,yBAAyB;EACzB,mBAAmB;AACrB;AACA;EACE,UAAU;EACV,WAAW;EACX,UAAU;EACV,WAAW;EACX,QAAQ;EACR,YAAY;EACZ,yBAAyB;EACzB,mBAAmB;AACrB;AACA;EACE,kBAAkB;EAClB,kBAAkB;EAClB,eAAe;EACf,mBAAmB;EACnB,WAAW;AACb;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,OAAO;EACP,MAAM;EACN,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,yBAAyB;EACzB,gBAAgB;EAChB,mDAAmD;AACrD;;AAEA;EACE,YAAY;EACZ,kBAAkB;EAClB,SAAS;EACT,UAAU;EACV,kBAAkB;EAClB,cAAc;EACd,iBAAiB;EACjB,kBAAkB;EAClB,yBAAyB;EACzB,WAAW;EACX,YAAY;EACZ,UAAU,EAAE,qBAAqB;;EAEjC,cAAc;AAChB;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,cAAc;;EAEd,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,iBAAiB,EAAE,aAAa;EAChC,gBAAgB;AAClB;AACA;EACE,aAAa;EACb,SAAS;EACT,gBAAgB;EAChB,mBAAmB;AACrB;AACA;EACE,aAAa;AACf;AACA;EACE,gBAAgB;EAChB,mBAAmB;AACrB;AACA;EACE,gBAAgB;;EAEhB,mBAAmB;AACrB;AACA;EACE,YAAY;AACd;AACA;EACE,YAAY;AACd;AACA;EACE,YAAY;EACZ,gBAAgB;AAClB;;AAEA;EACE;IACE,gBAAgB;IAChB,gBAAgB;IAChB,YAAY;EACd;AACF;AACA;EACE;IACE,gBAAgB;IAChB,gBAAgB;IAChB,YAAY;EACd;AACF;AACA;EACE,eAAe;EACf,mBAAmB;AACrB;AACA;EACE,kBAAkB;EAClB,yBAAyB;EACzB,gBAAgB;EAChB,mDAAmD;EACnD,aAAa;EACb,gBAAgB;;EAEhB,YAAY;EACZ,UAAU;EACV,QAAQ;EACR,OAAO;EACP,kBAAkB;EAClB,cAAc;EACd,QAAQ;AACV;AACA;EACE,cAAc;AAChB;AACA;EACE,yBAAyB;EACzB,kBAAkB;AACpB;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,YAAY;EACZ,eAAe;EACf,6BAA6B;AAC/B;AACA;EACE,kBAAkB;EAClB,mBAAmB;EACnB,yBAAyB;AAC3B;AACA;EACE,mBAAmB;EACnB,cAAc;EACd,yBAAyB;EACzB,mBAAmB;AACrB;AACA;EACE,cAAc;;EAEd,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,iBAAiB;AACnB;AACA;EACE,cAAc;;EAEd,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,iBAAiB;AACnB;AACA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,gBAAgB;AAClB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,cAAc;;EAEd,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,iBAAiB;AACnB;AACA;EACE,uBAAuB;EACvB,yBAAyB;;EAEzB,iBAAiB;EACjB,kBAAkB;EAClB,eAAe;EACf,cAAc;EACd,YAAY;EACZ,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,iBAAiB;EACjB,WAAW;EACX,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;EACzB,sBAAsB;AACxB;AACA;EACE,kBAAkB;EAClB,mBAAmB;EACnB,iDAAiD;EACjD,YAAY;EACZ,WAAW;EACX,kBAAkB;EAClB,YAAY;EACZ,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,iBAAiB;EACjB,kBAAkB;EAClB,eAAe;EACf,YAAY;AACd;AACA;EACE,yBAAyB;;EAEzB,aAAa;AACf;AACA;EACE,eAAe;EACf,cAAc;EACd,cAAc;AAChB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;AACpB;AACA;EACE,kBAAkB;EAClB,yBAAyB;EACzB,gBAAgB;EAChB,mDAAmD;EACnD,aAAa;EACb,YAAY;EACZ,iBAAiB;EACjB,aAAa;EACb,eAAe;EACf,QAAQ;EACR,SAAS;EACT,gCAAgC;AAClC;;AAEA;EACE,kBAAkB;EAClB,yBAAyB;EACzB,gBAAgB;EAChB,mDAAmD;EACnD,aAAa;EACb,YAAY;EACZ,iBAAiB;EACjB,aAAa;EACb,eAAe;EACf,QAAQ;EACR,SAAS;EACT,gCAAgC;AAClC;AACA;EACE,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,eAAe;EACf,aAAa;EACb,OAAO;EACP,MAAM;EACN,WAAW;EACX,YAAY;EACZ,oCAAoC;AACtC;AACA;EACE,kBAAkB;EAClB,SAAS;EACT,WAAW;EACX,YAAY;EACZ,eAAe;EACf,eAAe;AACjB;AACA;EACE,eAAe;EACf,gBAAgB;AAClB;AACA;EACE,iBAAiB;EACjB,kBAAkB;EAClB,aAAa;EACb,YAAY;;EAEZ,kBAAkB;EAClB,yBAAyB;EACzB,gBAAgB;EAChB,mDAAmD;EACnD,iBAAiB;EACjB,UAAU;AACZ;AACA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,kBAAkB;EAClB,sBAAsB;AACxB;AACA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,kBAAkB;EAClB,sBAAsB;AACxB;AACA;EACE,gBAAgB;AAClB;;AAEA;EACE,qBAAqB;EACrB,UAAU;EACV,SAAS;AACX;;AAEA;EACE,iBAAiB;EACjB,eAAe;EACf,cAAc;;EAEd,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,mBAAmB;;EAEnB,sBAAsB;EACtB,yBAAyB;EACzB,mBAAmB;EACnB,iCAAiC;AACnC;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,yBAAyB;EACzB,kBAAkB;EAClB,mBAAmB;AACrB;AACA;EACE,kBAAkB;EAClB,8BAA8B;EAC9B,aAAa;EACb,mBAAmB;EACnB,YAAY;EACZ,gBAAgB;EAChB,eAAe;AACjB;AACA;EACE,kBAAkB;EAClB,SAAS;EACT,YAAY;EACZ,eAAe;EACf,SAAS;EACT,YAAY;EACZ,kBAAkB;EAClB,yBAAyB;EACzB,gBAAgB;EAChB,mDAAmD;EACnD,iBAAiB;EACjB,UAAU;AACZ;AACA;EACE,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,kBAAkB;EAClB,yBAAyB;EACzB,gBAAgB;EAChB,iDAAiD;EACjD,aAAa;AACf;;AAEA;;EAEE,kBAAkB;EAClB,QAAQ;EACR,2BAA2B;AAC7B;AACA;EACE,YAAY;EACZ,aAAa;EACb,WAAW;EACX,kBAAkB;AACpB;AACA;EACE,SAAS;AACX;AACA;EACE,UAAU;AACZ;AACA;EACE,gBAAgB;AAClB;AACA;EACE,qBAAqB;EACrB,UAAU;EACV,SAAS;AACX;AACA;EACE,aAAa;EACb,QAAQ;EACR,iBAAiB;EACjB,eAAe;EACf,cAAc;;EAEd,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,mBAAmB;AACrB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,yBAAyB;EACzB,kBAAkB;EAClB,mBAAmB;AACrB;AACA;EACE,WAAW;EACX,YAAY;EACZ,gBAAgB;EAChB,+BAA+B;EAC/B,8BAA8B;AAChC;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,aAAa;AACf;AACA;EACE,cAAc;;EAEd,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,iBAAiB,EAAE,QAAQ;AAC7B;AACA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;AACrB;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,kBAAkB;AACpB;AACA;EACE,mBAAmB;AACrB;AACA;EACE,eAAe;EACf,+BAA+B;EAC/B,gBAAgB;EAChB,mBAAmB;EACnB,gBAAgB;AAClB;AACA;EACE,cAAc;;EAEd,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA;EACE;IACE,cAAc;IACd,eAAe;IACf,kBAAkB;IAClB,gBAAgB;IAChB,iBAAiB;IACjB,gBAAgB;IAChB,mBAAmB;IACnB,gBAAgB;IAChB,uBAAuB;EACzB;AACF;AACA;EACE,cAAc;;EAEd,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,iBAAiB;EACjB,mBAAmB;EACnB,gBAAgB;EAChB,uBAAuB;EACvB,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,yBAAyB;EACzB,gBAAgB;EAChB,iDAAiD;EACjD,cAAc;;EAEd,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,iBAAiB,EAAE,SAAS;EAC5B,iBAAiB;AACnB;;AAEA;EACE,gCAAgC;EAChC,gBAAgB;EAChB,gBAAgB;AAClB;AACA;EACE,aAAa;EACb,sBAAsB;EACtB,uBAAuB;EACvB,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,UAAU;AACZ;AACA;EACE,cAAc;EACd,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,iBAAiB,EAAE,WAAW;EAC9B,mBAAmB;EACnB,gBAAgB;EAChB,uBAAuB;EACvB,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;EACE,iBAAiB;EACjB,iBAAiB;EACjB,gBAAgB;EAChB,UAAU;AACZ;;AAEA;EACE,cAAc;EACd,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,YAAY;EACZ,kBAAkB;;EAElB,iBAAiB;AACnB;;AAEA;EACE,kBAAkB;EAClB,yBAAyB;EACzB,gBAAgB;EAChB,aAAa;AACf;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;AACX;AACA;EACE,cAAc;;EAEd,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,iBAAiB,EAAE,SAAS;EAC5B,+BAA+B;EAC/B,mBAAmB;AACrB;AACA;EACE,cAAc;EACd,iBAAiB;;EAEjB,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,iBAAiB;AACnB;AACA;EACE,aAAa;EACb,QAAQ;EACR,gBAAgB;AAClB;AACA;EACE,cAAc;;EAEd,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,iBAAiB;AACnB;AACA;EACE,cAAc;;EAEd,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,iBAAiB;AACnB;AACA;EACE,kBAAkB;EAClB,mBAAmB;EACnB,gBAAgB;EAChB,WAAW;EACX,kBAAkB;;EAElB,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,iBAAiB;EACjB,WAAW;AACb;AACA;EACE,aAAa;EACb,kBAAkB;EAClB,QAAQ;EACR,kBAAkB;EAClB,mBAAmB;EACnB,YAAY;EACZ,cAAc;EACd,OAAO;EACP,QAAQ;EACR,YAAY;EACZ,kBAAkB;EAClB,yBAAyB;EACzB,oCAAoC;EACpC,2BAA2B;EAC3B,eAAe;AACjB;AACA;EACE,cAAc;;EAEd,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,kBAAkB;EAClB,QAAQ;EACR,kBAAkB;EAClB,mBAAmB;EACnB,YAAY;EACZ,cAAc;EACd,OAAO;EACP,QAAQ;EACR,YAAY;EACZ,YAAY;EACZ,kBAAkB;EAClB,yBAAyB;EACzB,oCAAoC;EACpC,2BAA2B;EAC3B,eAAe;AACjB;AACA;EACE,cAAc;;EAEd,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,iBAAiB;AACnB;AACA;EACE,kBAAkB;EAClB,WAAW;EACX,UAAU;AACZ;;AAEA;EACE,cAAc;;EAEd,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,iBAAiB,EAAE,SAAS;AAC9B;AACA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;AACrB;AACA;EACE,cAAc;;EAEd,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,iBAAiB,EAAE,aAAa;AAClC;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;AACV;AACA;EACE,kBAAkB;EAClB,yBAAyB;EACzB,gBAAgB;EAChB,iDAAiD;EACjD,kBAAkB;EAClB,cAAc;EACd,kBAAkB;;EAElB,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,iBAAiB;EACjB,eAAe;AACjB;AACA;EACE,kBAAkB;EAClB,yBAAyB;EACzB,gBAAgB;EAChB,6CAA6C;AAC/C;AACA;EACE,kBAAkB;EAClB,mBAAmB;EACnB,iDAAiD;EACjD,YAAY;EACZ,kBAAkB;EAClB,WAAW;EACX,kBAAkB;;EAElB,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,iBAAiB;EACjB,eAAe;AACjB;AACA;EACE,kBAAkB;EAClB,yBAAyB;EACzB,mBAAmB;EACnB,cAAc;EACd,6CAA6C;EAC7C,mBAAmB;AACrB;AACA;EACE,mBAAmB;AACrB;AACA;EACE,qBAAqB;AACvB;;AAEA;EACE,kBAAkB;EAClB,yBAAyB;EACzB,gBAAgB;EAChB,mDAAmD;EACnD,aAAa;AACf;AACA;EACE,aAAa;EACb,QAAQ;AACV;AACA;EACE,kBAAkB;EAClB,SAAS;EACT,aAAa;EACb,mBAAmB;AACrB;AACA;EACE,cAAc;;EAEd,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,mBAAmB;AACrB;AACA;EACE,cAAc;;EAEd,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,mBAAmB;AACrB;AACA;EACE;cACY;EACZ,WAAW;EACX,sBAAsB;EACtB,eAAe;EACf,WAAW;AACb;AACA;EACE;IACE,WAAW;EACb;EACA;IACE,gBAAgB;EAClB;EACA;IACE,gBAAgB;EAClB;EACA;IACE,gBAAgB;IAChB,UAAU;IACV,kBAAkB;IAClB,MAAM;IACN,OAAO;IACP,WAAW;IACX,eAAe;EACjB;EACA;IACE,mBAAmB;EACrB;AACF;AACA;EACE,mBAAmB;EACnB,cAAc;EACd,iCAAiC;EACjC,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,iBAAiB;EACjB,qBAAqB;EACrB,yBAAyB;AAC3B;AACA;EACE,mBAAmB;EACnB,cAAc;AAChB;AACA;EACE,SAAS,EAAE,oCAAoC;EAC/C,aAAa;EACb,mBAAmB,EAAE,oCAAoC;AAC3D;AACA;EACE,kBAAkB;EAClB,qBAAqB;AACvB;AACA;8CAC8C;AAC9C;EACE,eAAe;EACf,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,sBAAsB;EACtB,mBAAmB;EACnB,WAAW;EACX,kBAAkB;EAClB;;cAEY;EACZ,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,iBAAiB;EACjB,mBAAmB;EACnB,2CAA2C;EAC3C,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,aAAa;EACb,oBAAoB;AACtB;AACA;EACE,WAAW;EACX,kBAAkB;EAClB,SAAS;EACT,oCAAoC;EACpC,2BAA2B;EAC3B,iBAAiB;EACjB,mBAAmB;EACnB,yDAAyD;AAC3D;;AAEA,8FAA8F;AAC9F;EACE,SAAS;EACT,YAAY;EACZ,yDAAyD;AAC3D;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,YAAY;AACd;AACA;EACE,UAAU;EACV,WAAW;EACX,kBAAkB;EAClB,yBAAyB;EACzB,YAAY;EACZ,kDAAkD;AACpD;AACA;EACE,qBAAqB;AACvB;AACA;EACE,qBAAqB;AACvB;AACA;EACE;;;IAGE,qBAAqB;IACrB,YAAY;EACd;EACA;IACE,qBAAqB;IACrB,UAAU;EACZ;AACF","sourcesContent":[".ChatBar-Main-Container {\n  width: 376px;\n  height: auto;\n  flex-shrink: 0;\n  border-right: 1px solid #e5e9ec;\n  background: #fff;\n  overflow: hidden;\n}\n\n.avatarContainer .MuiAvatar-root > svg {\n  width: 100%;\n  height: 100%;\n  display: block;\n}\n.message-status {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  gap: 4px;\n}\n\n.read-status,\n.delivered-status {\n  margin-right: 5px;\n}\n\n.sent-indicator {\n  color: #757575;\n  font-size: 11px;\n}\n.Chatbar-Heading {\n  color: #061522;\n\n  font-size: 24px;\n  font-style: normal;\n  font-weight: 500;\n  line-height: 18px; /* 75% */\n  padding-left: 24px;\n}\n.Message-Container {\n  display: flex;\n  justify-content: flex-start;\n  gap: 5px;\n}\n\n.agent-message {\n  justify-content: flex-end;\n}\n\n.user-message {\n  justify-content: flex-start;\n}\n\n.private-message {\n  justify-content: flex-end;\n}\n\n.Message-Content {\n  /* padding: 10px; */\n  /* max-width: 300px; */\n  /* max-width: 70%;  */\n}\n\n.mapImg {\n  width: 100%;\n  height: 100%;\n  object-fit: cover;\n}\n\n.Chat-Attachment {\n  width: 98px;\n  height: 98px;\n  border-radius: 8px;\n  float: right;\n  margin-bottom: 4px;\n}\n\n.Clear-Right {\n  clear: right;\n}\n\n.Img-Content-Agent {\n  max-width: fit-content;\n  /* height: 296px; */\n  background: #148dfd;\n  color: #fff;\n  padding: 15px;\n  border-radius: 8px;\n  width: 336px;\n  position: relative;\n}\n.Img-Content {\n  max-width: fit-content;\n  /* height: 296px; */\n  background: #f1f3f5;\n  padding: 15px;\n  border-radius: 8px;\n  position: relative;\n  width: 336px;\n}\n\n.Message-Img-Content {\n  padding: 10px;\n  max-width: 300px;\n  background-color: #148dfd;\n  border-radius: 16px 0px 16px 16px;\n  color: #fff;\n  font-size: 14px;\n  font-style: normal;\n  font-weight: 400;\n  line-height: 18px;\n  white-space: pre-wrap;\n  overflow-wrap: break-word;\n}\n\n.agent-message .Message-Content {\n  background-color: #148dfd;\n  border-radius: 16px 16px 0px 16px;\n  color: #fff;\n  font-size: 14px;\n  font-style: normal;\n  font-weight: 400;\n  line-height: 18px;\n  white-space: pre-wrap;\n  overflow-wrap: break-word;\n}\n\n.user-message .Message-Content {\n  background-color: #f1f3f5;\n  border-radius: 0px 16px 16px 16px;\n  font-size: 14px;\n  font-style: normal;\n  font-weight: 400;\n  line-height: 18px;\n  white-space: pre-wrap;\n  overflow-wrap: break-word;\n  color: #061522;\n}\n\n.ChatBar-Heading-Container {\n  display: flex;\n  align-items: center;\n  margin-top: 33px;\n  gap: 15px;\n  padding-left: 24px;\n}\n.chats-text {\n  color: #061522;\n\n  font-size: 14px;\n  font-style: normal;\n  font-weight: 500;\n  line-height: 18px;\n  cursor: pointer;\n  padding-bottom: 4px;\n}\n.Archive-text {\n  color: #405261;\n\n  font-size: 14px;\n  font-style: normal;\n  font-weight: 400;\n  line-height: 18px;\n  cursor: pointer;\n  padding-bottom: 4px;\n}\n.ChatBar-SearchInput {\n  margin-top: 16px;\n  padding-right: 32px;\n  padding-left: 24px;\n}\n.ChatUser-Main-Container {\n  background-color: #fff;\n  height: calc(100vh - 15em);\n  overflow: auto;\n  width: 99%;\n  padding-top: 20px;\n}\n\n/* Virtualized chat list: only the inner react-window scrolls (avoid double scrollbars). */\n.ChatUser-Main-Container.ChatUser-Main-Container--virtualized {\n  overflow: hidden !important;\n  padding-top: 0;\n}\n.ChatBar-Container01 {\n  margin-top: 6px;\n}\n.ChatUser-Container {\n  display: flex;\n  padding: 16px 24px;\n  cursor: pointer;\n}\n.ChatUser-ContainerActive {\n  border-radius: 9px;\n  background: #f7f8f9;\n  margin: 0px 16px;\n  padding: 16px;\n  padding-left: 8px;\n}\n.end-session-active {\n  border-radius: 9px;\n  background: #f7f8f9;\n  margin: 0px 16px;\n  padding: 16px;\n  opacity: 80%;\n}\n.end-session-active-title {\n  color: #405261 !important;\n}\n.Chat-User-Main {\n  display: flex;\n  flex-direction: column;\n  width: 90%;\n  margin-left: 10px;\n  gap: 7px;\n}\n\n.Chat-User00 {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n}\n.Chat-User02 {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n}\n.Chat-User03 {\n  display: flex;\n  align-items: center;\n  gap: 5px;\n}\n.Chat-User-Kathryn {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n}\n.ChatUser-text {\n  color: #061522;\n  font-size: 14px;\n  font-style: normal;\n  font-weight: 500;\n  line-height: 18px;\n  max-width: 115px;\n  white-space: nowrap;\n  overflow: hidden;\n  text-overflow: ellipsis;\n}\n\n.ChatUser-time {\n  color: #405261;\n  text-align: right;\n\n  font-size: 12px;\n  font-style: normal;\n  font-weight: 400;\n  line-height: 18px;\n}\n.ChatUser-discreption {\n  color: #405261;\n\n  font-size: 14px;\n  font-style: normal;\n  font-weight: 400;\n  line-height: 18px;\n  white-space: nowrap;\n  width: 240px;\n  overflow: hidden;\n  text-overflow: ellipsis;\n}\n.Typing {\n  color: #389e0d;\n  font-size: 14px;\n  font-style: normal;\n  font-weight: 500;\n  line-height: 18px;\n}\n\n.ActiveUser-Max {\n  color: #405261;\n\n  font-size: 12px;\n  font-style: normal;\n  font-weight: 400;\n  line-height: 12px; /* 100% */\n}\n.ChatHeader-Main-Container {\n  display: flex;\n  border-bottom: 1px solid #e5e9ec;\n\n  position: sticky;\n  top: 0;\n  opacity: 60;\n  opacity: 60;\n\n  /* Above message-area layers (e.g. time tooltips z-index: 10) so header is not covered */\n  z-index: 50;\n\n  /* 👇 semi-transparent instead of solid */\n  /* 👇 semi-transparent instead of solid */\n  background: rgba(255, 255, 255, 0.4);\n  backdrop-filter: blur(15px);\n  -webkit-backdrop-filter: blur(15px); /* Safari support */\n  box-sizing: border-box;\n}\n\n.ChatHeader-Container {\n  width: 100%;\n\n  padding: 7px 24px;\n  background: rgba(255, 255, 255, 0.4);\n  backdrop-filter: blur(15px);\n  align-items: center;\n}\n.ChatHeader-Logo-Container {\n  display: flex;\n  align-items: center;\n  gap: 24px;\n  /* margin-top: 20px; */\n  position: relative;\n}\n.ChatHeader-Logo-Container p {\n  position: relative;\n  cursor: pointer;\n}\n.ChatHeader-Text {\n  color: #061522;\n\n  font-size: 24px;\n  font-style: normal;\n  font-weight: 500;\n  line-height: 20px;\n}\n\n@media screen and (max-width: 1440px) {\n  .ChatHeader-Text {\n    color: #061522;\n    font-size: 24px;\n    font-style: normal;\n    font-weight: 500;\n    line-height: 20px;\n    max-width: 300px;\n    white-space: nowrap;\n    overflow: hidden;\n    text-overflow: ellipsis;\n  }\n}\n.ChatHeader-ClockContainer {\n  display: flex;\n  /* margin-top: 18px; */\n  gap: 10px;\n}\n.line {\n  width: 1px;\n  height: 16px;\n  background: #e5e9ec;\n}\n.ChatHeaderTxt {\n  color: #405261;\n\n  font-size: 12px;\n  font-style: normal;\n  font-weight: 400;\n  line-height: 12px; /* 100% */\n  min-width: 124px;\n  margin-top: 2px;\n  margin-left: -4px;\n}\n\n.ChatMessage-Container {\n  /* height: 100%; */\n  position: relative;\n  z-index: 0;\n}\n.ChatMessageComponent-Container {\n  width: 100%;\n  height: 100%;\n  position: relative;\n  display: flex;\n  flex-direction: column;\n  overflow: hidden;\n}\n\n.ChatMessageComponent-Container-Ticket {\n  width: 100%;\n  height: 100%;\n  position: relative;\n  display: flex;\n  flex-direction: column;\n  overflow: hidden;\n}\n.MessageComponet-Main {\n  position: relative;\n  flex: 1;\n  min-height: 0;\n  overflow: hidden;\n  display: flex;\n  flex-direction: column;\n}\n.MessageComponent-Main-02 {\n  overflow-y: auto;\n  height: calc(100vh - 22em);\n  -webkit-box-flex: 1;\n  /* flex-grow: 1; */\n  overscroll-behavior-y: contain;\n  padding: 25px;\n  padding-bottom: 0px;\n}\n.TicketMessageComponent-Main-02 {\n  flex: 1;\n  min-height: 0;\n  padding: 24px;\n  padding-bottom: 0;\n  overscroll-behavior-y: contain;\n  overflow: hidden;\n  position: relative;\n}\n\n.TicketMessageComponent-Main-02 .scroll-wrapper {\n  height: 100%;\n  overflow-y: auto;\n  overflow-x: hidden;\n  padding-right: 8px;\n}\n\n.TicketMessageComponent-Main-02 .scroll-wrapper::-webkit-scrollbar {\n  width: 6px;\n}\n\n.TicketMessageComponent-Main-02 .scroll-wrapper::-webkit-scrollbar-track {\n  background: transparent;\n}\n\n.ChatMessage_Container_Input {\n  display: flex;\n  flex-shrink: 0;\n  padding: 0.75rem;\n  padding-left: 24px;\n  padding-right: 24px;\n}\n.ChatMessageInput-Main-Container {\n  width: 100%;\n  border-radius: 8px;\n  border: 1px solid #d5dce1;\n  background: #fff;\n  box-shadow: 0px 1px 2px 0px rgba(6, 21, 34, 0.05);\n  /* height: 136px; */\n  padding: 12px 24px 24px;\n}\n.clearImg {\n  cursor: pointer;\n  position: absolute;\n}\n.ChatInput {\n  border: none;\n  width: 100%;\n\n  font-family: \"Inter\", sans-serif;\n  min-height: 46px;\n  height: auto;\n  outline: none;\n  padding-top: 6px;\n  resize: none;\n  overflow: hidden;\n  font-size: 16px;\n}\n\n.ChatInput::placeholder {\n  color: #c5ced6;\n\n  font-size: 16px;\n  font-style: normal;\n  font-weight: 400;\n  line-height: 18px; /* 112.5% */\n}\n\n.ChatMessage-Button-Container {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  margin-top: 10px;\n}\n.ChatMessage-Emoji00 {\n  display: flex;\n  align-items: center;\n  gap: 16px;\n}\n.ChatMessage-Emoji00 p {\n  cursor: pointer;\n}\n.Archive-Info {\n  position: relative;\n  bottom: -1rem;\n  width: -webkit-fill-available;\n}\n.Archive-Section {\n  display: flex;\n  justify-content: space-between;\n  border: 1px solid #d5dce1;\n  align-items: center;\n  height: 88px;\n  padding: 0 20px;\n  border-radius: 8px;\n  margin: 0px 24px;\n  margin-bottom: 20px;\n  width: -webkit-fill-available;\n  margin-top: 60px;\n}\n.ChatArchived-Hr {\n  border: none;\n  border-top: 1px solid #ccc;\n  margin: 30px 0;\n}\n.Archive-msg {\n  color: #061522;\n}\n.OpenChat-Button {\n  margin-top: 15px;\n  border-radius: 5px;\n  background: #148dfd;\n  box-shadow: 0px 1px 2px 0px rgba(6, 21, 34, 0.05);\n  padding: 11px 36px;\n  border: none;\n  color: #fff;\n\n  font-size: 14px;\n  font-style: normal;\n  font-weight: 500;\n  cursor: pointer;\n  line-height: 18px;\n}\n.StartChat-Button {\n  margin-top: 15px;\n  border-radius: 5px;\n  background: #148dfd;\n  box-shadow: 0px 1px 2px 0px rgba(6, 21, 34, 0.05);\n  padding: 11px 36px;\n  border: none;\n  color: #fff;\n\n  font-size: 14px;\n  font-style: normal;\n  font-weight: 500;\n  cursor: pointer;\n  line-height: 18px;\n}\n.ChatInput-Button {\n  border-radius: 5px;\n  background: #148dfd;\n  box-shadow: 0px 1px 2px 0px rgba(6, 21, 34, 0.05);\n  padding: 11px 36px;\n  border: none;\n  color: #fff;\n\n  font-size: 14px;\n  font-style: normal;\n  font-weight: 500;\n  cursor: pointer;\n  line-height: 18px;\n}\n.ChatInput-Button:not(:disabled):hover {\n  background-color: #0077cc;\n\n  outline: none;\n}\n.ChatMessage-Footer-Container {\n  padding-bottom: 37px;\n}\n/* Align Tags: with Archive-Section left edge (margin: 0 24px) */\n.ChatMessage-Footer-Container--archive {\n  margin: 0 24px;\n  padding-bottom: 37px;\n}\n.ChatMessage-Footer-Container--archive .ChatMessage-Footer {\n  padding: 0;\n}\n.ChatMessage-Footer {\n  padding: 0px 24px;\n}\n\n.ChatMessage-Footer01 {\n  width: 100%;\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n}\n.Message-Time-Header-Comment {\n  width: 100%;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  gap: 13px;\n  width: 100%;\n  margin-top: 0.75rem;\n  margin-bottom: 29px;\n}\n.Message-Time-Header {\n  width: 100%;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  gap: 10px;\n  width: 100%;\n  margin-top: 0.75rem;\n}\n.Message-Time-Header-Ended {\n  width: 100%;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  gap: 10px;\n  width: 100%;\n  margin-top: 0.75rem;\n  margin-bottom: 29px;\n}\n.Left-Chat-Container {\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  gap: 8px;\n  padding-bottom: 32px;\n}\n.ant-switch .ant-switch-handle {\n  width: 16px !important;\n  height: 16px !important;\n}\n.Left-Chat-Text {\n  color: #061522;\n  font-size: 14px;\n  font-style: normal;\n  font-weight: 400;\n  line-height: 12px;\n}\n.Chat-Comment-Container {\n  text-align: center;\n  padding-bottom: 32px;\n}\n.Chat-Comment {\n  color: #061522;\n  font-size: 14px;\n  font-style: normal;\n  font-weight: 400;\n  line-height: 12px;\n  padding-bottom: 16px;\n}\n.Chat-Comment-Text {\n  color: #405261;\n  font-size: 14px;\n  font-weight: 400;\n  line-height: 12px;\n  font-style: italic;\n}\n.Message-Time-Text {\n  color: #405261;\n  text-align: center;\n  font-size: 12px;\n  font-style: normal;\n  font-weight: 400;\n  line-height: 12px;\n}\n.Left-Line {\n  flex: 1;\n  height: 1px;\n  background: #f1f3f5;\n}\n.right-Line {\n  flex: 1;\n  height: 1px;\n  background: #f1f3f5;\n}\n\n@media screen and (max-width: 1600px) {\n  .Left-Line {\n    height: 1px;\n    background: #f1f3f5;\n  }\n  .right-Line {\n    width: 35%;\n    height: 1px;\n    background: #f1f3f5;\n  }\n}\n.ChatMessage-Footer-div01 {\n  display: flex;\n  align-items: center;\n  gap: 6px;\n}\n.ChatMessage-Footer-div01 p {\n  cursor: pointer;\n}\n.ChatFooter-text {\n  color: #405261;\n\n  font-size: 12px;\n  font-style: normal;\n  font-weight: 400;\n  line-height: 12px; /* 100% */\n}\n.privateMode-Container {\n  display: flex;\n  align-items: center;\n  gap: 6px;\n}\n.privateMode-text {\n  color: #061522;\n  text-align: right;\n\n  font-size: 12px;\n  font-style: normal;\n  font-weight: 500;\n  line-height: 14px; /* 116.667% */\n}\n.Message-User-Container-left {\n  display: flex;\n  flex-direction: row;\n  width: 100%;\n  justify-content: flex-start;\n  align-self: flex-start;\n  gap: 8px;\n  margin: 10px 0px;\n}\n.Message-User-Container-box {\n  padding: 15px;\n  border-radius: 1px 16px 16px 16px;\n  background: #f1f3f5;\n  cursor: pointer;\n  max-width: 50%;\n}\n.Message-User-Container-right {\n  margin-top: 12px;\n  display: flex;\n  flex-direction: row-reverse;\n  align-items: flex-end;\n  align-self: flex-end;\n  width: 100%;\n  gap: 8px;\n}\n.Message-User-Message-Right001 {\n  border-radius: 16px 16px 0px 16px;\n  background: #148dfd;\n  padding: 15px;\n  max-width: 50%;\n  flex-wrap: wrap;\n  display: flex;\n}\n\n.rightuser-time {\n  display: flex;\n  justify-content: flex-end;\n  align-items: end;\n}\n.User-Message-rightSide {\n  color: #fff;\n\n  font-size: 14px;\n  font-style: normal;\n  font-weight: 400;\n  line-height: 18px;\n  white-space: pre-wrap;\n  word-break: break-word;\n  overflow-wrap: break-word;\n}\n\n.First-Message-Heading {\n  background-color: #f1f3f5;\n  border-radius: 0 16px 0 0;\n  font-size: 14px;\n  font-weight: 500;\n  padding: 0 0 0 14px;\n}\n\n.First-Message-Content {\n  min-width: 300px;\n  background-color: #ffffff;\n  border-radius: 0 0 16px 16px;\n  border: 14px solid #f1f3f5;\n  padding: 16px;\n}\n\n.First-Message-Text {\n  font-size: 14px;\n  color: #061522;\n}\n.Message-Text {\n  padding-top: 0px;\n}\n.highlight {\n  color: #405261;\n  font-size: 12px;\n  font-weight: 400;\n}\n\n.User-message-text {\n  text-align: left;\n  color: #fff;\n  font-size: 14px;\n  font-style: normal;\n  font-weight: 400;\n  line-height: 18px;\n  white-space: pre-wrap;\n  overflow-wrap: break-word;\n}\n\n.User-message-text-down {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  gap: 8px;\n}\n.User-messagetext01 {\n  color: #061522;\n\n  font-size: 12px;\n  font-style: normal;\n  font-weight: 400;\n  line-height: 12px; /* 100% */\n}\n.User-Messagetime01 {\n  color: #556575;\n  text-align: right;\n\n  font-size: 12px;\n  font-style: normal;\n  font-weight: 400;\n  line-height: 12px; /* 100% */\n}\n.User-Messagetime02 {\n  color: #556575;\n  text-align: right;\n\n  font-size: 12px;\n  font-style: normal;\n  font-weight: 400;\n  line-height: 12px; /* 100% */\n  margin-top: 10px;\n}\n.dropdown-chat-menu {\n  position: absolute;\n  top: calc(100% + 5px);\n  right: 0;\n  width: 176px;\n  box-sizing: border-box;\n  border-radius: 8px;\n  border: 1px solid #d5dce1;\n  background: #fff;\n  box-shadow: 0 15px 20px 0 rgba(6, 21, 34, 0.05);\n  padding: 0;\n  z-index: 9999;\n}\n.dropdown-chat-menu:hover {\n  background: #fff;\n}\n.dropdown-chat-menu ul {\n  list-style-type: none;\n  padding: 0;\n  margin: 0;\n}\n.dropdown-chat-menu ul li {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  padding: 10px 16px;\n  min-height: 0;\n  cursor: pointer;\n  color: #061522;\n  font-family: \"Inter\", sans-serif;\n  font-size: 14px;\n  font-style: normal;\n  font-weight: 400;\n  line-height: 18px;\n}\n.dropdown-chat-menu ul:hover {\n  background: #fff;\n}\n.dropdown-chat-menu ul .stop-chat-text {\n  color: #e53935;\n}\n.dropdown-chat-menu ul li:hover {\n  background-color: rgba(6, 21, 34, 0.04);\n  border-radius: 0;\n  color: #061522;\n}\n.dropdown-chat-menu ul .stop-chat-text:hover {\n  background-color: rgba(229, 57, 53, 0.06);\n  color: #e53935;\n}\n.Ticket-Button-Container {\n  display: flex;\n  gap: 8px;\n  margin-top: 16px;\n}\n.logout-button-container {\n  display: flex;\n  gap: 8px;\n}\n.buttonstyle-Cancel {\n  margin: auto;\n  width: 49%;\n  height: 40px;\n  flex-shrink: 0;\n  border-radius: 8px;\n  border: 1px solid #d5dce1;\n  background: #fff;\n  box-shadow: 0px 1px 2px 0px rgba(6, 21, 34, 0.05);\n  color: #405261;\n\n  font-size: 14px;\n  font-style: normal;\n  font-weight: 500;\n  line-height: 18px;\n  cursor: pointer;\n}\n.buttonstyle-Cancel:not(:disabled):hover {\n  background-color: #ffffff;\n  border-color: #c5ced6;\n\n  outline: none;\n}\n.buttonstyle-Ticket {\n  margin: auto;\n  width: 49%;\n  height: 40px;\n  flex-shrink: 0;\n  border-radius: 8px;\n  border: 1px solid #d5dce1;\n  background: #148dfd;\n  box-shadow: 0px 1px 2px 0px rgba(6, 21, 34, 0.05);\n  border: none;\n  color: #fff;\n\n  font-size: 14px;\n  font-style: normal;\n  font-weight: 500;\n  line-height: 18px;\n  cursor: pointer;\n}\n.buttonstyle-Ticket:not(:disabled):hover {\n  background-color: #0077cc;\n}\n\n.buttonstyle-Ticket:disabled {\n  background: #f9fafa;\n  color: #93a1b0;\n  border: 1px solid #c5ced6;\n  cursor: not-allowed;\n}\n.activeChat {\n  display: inline-block; /* 👈 important */\n  color: #061522;\n  font-size: 14px;\n  font-style: normal;\n  font-weight: 500;\n  line-height: 18px;\n  border-bottom: 1px solid #148dfd;\n  cursor: pointer;\n}\n\n.check__box__chat {\n  display: flex;\n  margin-top: 14px;\n}\n.block__check__chat {\n  align-items: center;\n}\n\n.custom-checkbox__chat {\n  display: none;\n}\n.onlineStatus {\n  width: 8px;\n  height: 8px;\n  top: 275px;\n  left: 144px;\n  gap: 0px;\n  opacity: 0px;\n  background-color: #389e0d;\n  border-radius: 20px;\n}\n.offlineStatus {\n  width: 8px;\n  height: 8px;\n  top: 275px;\n  left: 144px;\n  gap: 0px;\n  opacity: 0px;\n  background-color: #93a1b0;\n  border-radius: 20px;\n}\n.custom-checkbox__chat + label {\n  position: relative;\n  padding-left: 20px;\n  cursor: pointer;\n  align-items: center;\n  bottom: 4px;\n}\n\n.custom-checkbox__chat + label::before {\n  content: \"\";\n  position: absolute;\n  left: 0;\n  top: 0;\n  width: 18px;\n  height: 18px;\n  border-radius: 4px;\n  border: 1px solid #d5dce1;\n  background: #fff;\n  box-shadow: 0px 1px 2px 0px rgba(20, 141, 253, 0.1);\n}\n\n.custom-checkbox__chat + label::after {\n  content: \"✔\";\n  position: absolute;\n  left: 0px;\n  top: 0.5px;\n  text-align: center;\n  color: #148dfd;\n  stroke-width: 1px;\n  border-radius: 4px;\n  border: 1px solid #148dfd;\n  width: 18px;\n  height: 18px;\n  opacity: 0; /* Initially hidden */\n\n  flex-shrink: 0;\n}\n\n.custom-checkbox__chat:checked + label::after {\n  opacity: 1;\n}\n\n.Remember__01_chat {\n  color: #405261;\n\n  font-size: 14px;\n  font-style: normal;\n  font-weight: 400;\n  line-height: 20px; /* 142.857% */\n  margin-left: 8px;\n}\n.ChatAgent-Main-Container {\n  display: flex;\n  gap: 30px;\n  margin-top: 22px;\n  margin-bottom: 14px;\n}\n.ChatAgent-Main-Container-Assign {\n  display: flex;\n}\n.SearchChat-Popup-Assign {\n  margin-top: 14px;\n  margin-bottom: 22px;\n}\n.SearchChat-Popup-Feedback {\n  margin-top: 16px;\n\n  margin-bottom: 16px;\n}\n.SearchInputField-FeedBack {\n  height: 40px;\n}\n.SearchInputField-kb {\n  height: 60px;\n}\n.SearchInputField-kb-layout {\n  height: 60px;\n  min-width: 430px;\n}\n\n@media (max-width: 601px) {\n  .SearchInputField-kb-layout {\n    min-width: unset;\n    min-width: 150px;\n    height: 40px;\n  }\n}\n@media (max-width: 900px) {\n  .SearchInputField-kb-layout {\n    min-width: unset;\n    min-width: 220px;\n    height: 40px;\n  }\n}\n.SearchChat-Popup {\n  margin-top: 8px;\n  margin-bottom: 22px;\n}\n.Assign-PopUp-Container {\n  border-radius: 8px;\n  border: 1px solid #d5dce1;\n  background: #fff;\n  box-shadow: 0px 15px 20px 0px rgba(6, 21, 34, 0.05);\n  padding: 32px;\n  max-width: 424px;\n\n  height: auto;\n  z-index: 1;\n  right: 0;\n  left: 0;\n  position: absolute;\n  margin: 0 auto;\n  top: 15%;\n}\n.AgentsList {\n  padding: 0 2px;\n}\n.ChatPopup-Darleen-Container:hover {\n  background-color: #f9fafa;\n  border-radius: 8px;\n}\n.ChatPopup-Darleen-Container {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  padding: 8px;\n  cursor: pointer;\n  border: 1px solid transparent;\n}\n.ChatPopup-Darleen-Container.selected {\n  border-radius: 8px;\n  background: #f3fbff;\n  border: 1px solid #148dfd;\n}\n.AddTansfer:disabled {\n  background: #f9fafa;\n  color: #93a1b0;\n  border: 1px solid #c5ced6;\n  cursor: not-allowed;\n}\n.Albert-text {\n  color: #061522;\n\n  font-size: 14px;\n  font-style: normal;\n  font-weight: 500;\n  line-height: 18px;\n}\n.No-activetext {\n  color: #556575;\n\n  font-size: 14px;\n  font-style: normal;\n  font-weight: 400;\n  line-height: 18px;\n}\n.AssignChat-footer {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  margin-top: 30px;\n}\n.AssignTicket-footer {\n  margin-top: 30px;\n}\n.Add-PrivateChat {\n  color: #061522;\n\n  font-size: 14px;\n  font-style: normal;\n  font-weight: 500;\n  line-height: 18px;\n}\n.cancel-btn {\n  background: transparent;\n  border: 1px solid #d5dce1;\n\n  padding: 8px 16px;\n  border-radius: 8px;\n  cursor: pointer;\n  color: #061522;\n  height: 40px;\n  font-size: 14px;\n  font-style: normal;\n  font-weight: 500;\n  line-height: 18px;\n  width: 100%;\n  transition: all 0.2s ease;\n}\n\n.cancel-btn:not(:disabled):hover {\n  border: 1px solid #c5ced6;\n  background-color: #fff;\n}\n.AddTansfer {\n  border-radius: 8px;\n  background: #148dfd;\n  box-shadow: 0px 1px 2px 0px rgba(6, 21, 34, 0.05);\n  border: none;\n  color: #fff;\n  text-align: center;\n  float: right;\n  font-size: 14px;\n  font-style: normal;\n  font-weight: 500;\n  line-height: 18px;\n  padding: 11px 17px;\n  cursor: pointer;\n  width: 112px;\n}\n.AddTansfer:not(:disabled):hover {\n  background-color: #0077cc;\n\n  outline: none;\n}\n.chat-txt {\n  font-size: 12px;\n  color: #405261;\n  margin: 10px 0;\n}\n\n.thumbnail-image {\n  width: 98px;\n  height: 98px;\n  border-radius: 8px;\n}\n.Canned-PopUp-Container {\n  border-radius: 8px;\n  border: 1px solid #d5dce1;\n  background: #fff;\n  box-shadow: 0px 15px 20px 0px rgba(6, 21, 34, 0.05);\n  padding: 30px;\n  width: 424px;\n  max-height: 440px;\n  z-index: 1000;\n  position: fixed;\n  top: 50%;\n  left: 50%;\n  transform: translate(-50%, -50%);\n}\n\n.Canned-PopUp-Container01 {\n  border-radius: 8px;\n  border: 1px solid #d5dce1;\n  background: #fff;\n  box-shadow: 0px 15px 20px 0px rgba(6, 21, 34, 0.05);\n  padding: 30px;\n  width: 424px;\n  max-height: 440px;\n  z-index: 1000;\n  position: fixed;\n  top: 50%;\n  left: 50%;\n  transform: translate(-50%, -50%);\n}\n.modal {\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  position: fixed;\n  z-index: 1000;\n  left: 0;\n  top: 0;\n  width: 100%;\n  height: 100%;\n  background-color: rgba(0, 0, 0, 0.9);\n}\n.modal-close {\n  position: absolute;\n  top: 20px;\n  right: 35px;\n  color: white;\n  font-size: 30px;\n  cursor: pointer;\n}\n.modal-image {\n  max-width: 100%;\n  max-height: 100%;\n}\n.dropdown-canned-tag {\n  max-height: 400px;\n  position: absolute;\n  bottom: 100px;\n  width: 256px;\n\n  border-radius: 8px;\n  border: 1px solid #d5dce1;\n  background: #fff;\n  box-shadow: 0px 15px 20px 0px rgba(6, 21, 34, 0.05);\n  padding: 8px 11px;\n  z-index: 1;\n}\n.dropdown-canned-tag-list {\n  max-height: 309px;\n  overflow-y: auto;\n  overflow-x: hidden;\n  box-sizing: border-box;\n}\n.dropdown-canned-msg-list {\n  max-height: 345px;\n  overflow-y: auto;\n  overflow-x: hidden;\n  box-sizing: border-box;\n}\n.dropdown-canned-tag:hover {\n  background: #fff;\n}\n\n.dropdown-canned-tag ul {\n  list-style-type: none;\n  padding: 0;\n  margin: 0;\n}\n\n.dropdown-canned-tag ul li {\n  padding: 9px 10px;\n  cursor: pointer;\n  color: #405261;\n\n  font-size: 14px;\n  font-style: normal;\n  font-weight: 400;\n  line-height: normal;\n\n  word-break: break-word;\n  overflow-wrap: break-word;\n  white-space: normal;\n  transition: background-color 0.3s;\n}\n\n.dropdown-canned-tag ul:hover {\n  background: #fff;\n}\n\n.dropdown-canned-tag ul li:hover {\n  background-color: #f5f5f5;\n  border-radius: 8px;\n  background: #f9fafa;\n}\n.button-container-tag {\n  position: relative;\n  justify-content: space-between;\n  display: flex;\n  align-items: center;\n  padding: 6px;\n  background: #fff;\n  cursor: default;\n}\n.dropdown-chat-tag {\n  position: absolute;\n  right: 0%;\n  width: 232px;\n  /* top: 50px; */\n  left: 20%;\n  bottom: 30px;\n  border-radius: 8px;\n  border: 1px solid #d5dce1;\n  background: #fff;\n  box-shadow: 0px 15px 20px 0px rgba(6, 21, 34, 0.05);\n  padding: 8px 11px;\n  z-index: 1;\n}\n.input-container-tag {\n  position: relative;\n  display: flex;\n  align-items: center;\n  border-radius: 8px;\n  border: 1px solid #d5dce1;\n  background: #fff;\n  box-shadow: 0px 1px 2px 0px rgba(6, 21, 34, 0.05);\n  padding: 13px;\n}\n\n.input-icon-left,\n.input-icon-right {\n  position: absolute;\n  top: 55%;\n  transform: translateY(-50%);\n}\n.TagInput {\n  border: none;\n  outline: none;\n  width: 100%;\n  padding-left: 20px;\n}\n.input-icon-left {\n  left: 8px;\n}\n.input-icon-right {\n  right: 8px;\n}\n.dropdown-chat-tag:hover {\n  background: #fff;\n}\n.dropdown-chat-tag ul {\n  list-style-type: none;\n  padding: 0;\n  margin: 0;\n}\n.dropdown-chat-tag ul li {\n  display: flex;\n  gap: 8px;\n  padding: 9px 10px;\n  cursor: pointer;\n  color: #405261;\n\n  font-size: 14px;\n  font-style: normal;\n  font-weight: 400;\n  line-height: normal;\n}\n.dropdown-chat-tag ul:hover {\n  background: #fff;\n}\n.dropdown-chat-tag ul li:hover {\n  background-color: #f5f5f5;\n  border-radius: 8px;\n  background: #f9fafa;\n}\n.ChatSideBar-Main-Container {\n  width: 26em;\n  height: 100%;\n  overflow: hidden;\n  transition: transform 0.3s ease;\n  border-left: 1px solid #e5e9ec;\n}\n\n.Chat-SideBar-Heading {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  padding: 24px;\n}\n.SideBar-details {\n  color: #061522;\n\n  font-size: 24px;\n  font-style: normal;\n  font-weight: 500;\n  line-height: 18px; /* 75% */\n}\n.ChatSideBar-Profile {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n}\n.ChatSideBar-profile-cotnainer {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  position: relative;\n}\n.ChatSideBar-CutomerDetails {\n  margin-bottom: 30px;\n}\n.ChatSideBar-Content-Container {\n  padding: 0 24px;\n  max-height: calc(100vh - 400px);\n  overflow-y: auto;\n  margin-bottom: 10px;\n  margin-top: 16px;\n}\n.Kriti-Watson {\n  color: #061522;\n\n  font-size: 16px;\n  font-style: normal;\n  font-weight: 500;\n  line-height: 18px;\n}\n\n@media screen and (max-width: 1600px) {\n  .Kriti-Watson {\n    color: #061522;\n    font-size: 16px;\n    font-style: normal;\n    font-weight: 500;\n    line-height: 18px;\n    max-width: 225px;\n    white-space: nowrap;\n    overflow: hidden;\n    text-overflow: ellipsis;\n  }\n}\n.nathan-johnes {\n  color: #405261;\n\n  font-size: 14px;\n  font-style: normal;\n  font-weight: 400;\n  line-height: 18px;\n  white-space: nowrap;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  max-width: 140px;\n}\n\n.ChatSideBar-ClientButton {\n  border-radius: 5px;\n  border: 1px solid #d5dce1;\n  background: #fff;\n  box-shadow: 0px 1px 2px 0px rgba(6, 21, 34, 0.05);\n  color: #405261;\n\n  font-size: 12px;\n  font-style: normal;\n  font-weight: 400;\n  line-height: 18px; /* 150% */\n  padding: 3px 16px;\n}\n\n.Sidebar-bottomLine {\n  border-bottom: 1px solid #e5e9ec;\n  background: #fff;\n  margin: 16px 0px;\n}\n.ChatSideBar-Container-customer {\n  display: flex;\n  flex-direction: column;\n  align-items: flex-start;\n  padding: 12px 0px;\n}\n\n.ChatSidear-customer {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  width: 50%;\n}\n.sidebar-content01 {\n  color: #061522;\n  font-size: 16px;\n  font-style: normal;\n  font-weight: 400;\n  line-height: 18px; /* 112.5% */\n  white-space: nowrap;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  margin-left: 32px;\n  max-width: 250px;\n}\n\n.sidebar-content01:hover {\n  overflow: visible;\n  white-space: wrap;\n  background: #fff;\n  z-index: 1;\n}\n\n.chatsidebar-content02 {\n  color: #405261;\n  font-size: 14px;\n  font-style: normal;\n  font-weight: 400;\n  height: 24px;\n  align-self: center;\n\n  line-height: 18px;\n}\n\n.ChatSideBar-Footer-Container {\n  border-radius: 8px;\n  border: 1px solid #e5e9ec;\n  background: #fff;\n  padding: 24px;\n}\n.ChatSideBar-FooterHeading {\n  display: flex;\n  align-items: center;\n  gap: 16px;\n}\n.visited-page01 {\n  color: #061522;\n\n  font-size: 18px;\n  font-style: normal;\n  font-weight: 500;\n  line-height: 18px; /* 100% */\n  border-right: 1px solid #061522;\n  padding-right: 10px;\n}\n.viewedpage {\n  color: #405261;\n  text-align: right;\n\n  font-size: 14px;\n  font-style: normal;\n  font-weight: 400;\n  line-height: 18px;\n}\n.livechat-footer {\n  display: flex;\n  gap: 8px;\n  margin-top: 22px;\n}\n.chat-sidefooter-user {\n  color: #061522;\n\n  font-size: 14px;\n  font-style: normal;\n  font-weight: 500;\n  line-height: 18px;\n}\n.chat-sidefooter-user01 {\n  color: #405261;\n\n  font-size: 14px;\n  font-style: normal;\n  font-weight: 400;\n  line-height: 18px;\n}\n.ChatUser-red {\n  border-radius: 9px;\n  background: #ff4d4f;\n  padding: 0px 8px;\n  color: #fff;\n  text-align: center;\n\n  font-size: 12px;\n  font-style: normal;\n  font-weight: 700;\n  line-height: 18px;\n  width: 29px;\n}\n.ScrollToTop-Main-Container {\n  display: flex;\n  position: absolute;\n  gap: 6px;\n  padding: 11px 25px;\n  align-items: center;\n  width: 259px;\n  margin: 0 auto;\n  left: 0;\n  right: 0;\n  height: 40px;\n  border-radius: 8px;\n  border: 1px solid #e5e9ec;\n  background: rgba(255, 255, 255, 0.4);\n  backdrop-filter: blur(15px);\n  cursor: pointer;\n}\n.SCrollTop-Text {\n  color: #405261;\n\n  font-size: 14px;\n  font-style: normal;\n  font-weight: 400;\n  line-height: 18px;\n}\n\n.ScrollToTop-Main-Container-Btm {\n  display: flex;\n  position: absolute;\n  gap: 6px;\n  padding: 11px 22px;\n  align-items: center;\n  width: 280px;\n  margin: 0 auto;\n  left: 0;\n  right: 0;\n  bottom: 10px;\n  height: 40px;\n  border-radius: 8px;\n  border: 1px solid #e5e9ec;\n  background: rgba(255, 255, 255, 0.4);\n  backdrop-filter: blur(15px);\n  cursor: pointer;\n}\n.SCrollTop-Text-Btm {\n  color: #405261;\n\n  font-size: 14px;\n  font-style: normal;\n  font-weight: 400;\n  line-height: 18px;\n}\n.EmojiPicker-Top {\n  position: absolute;\n  bottom: 20%;\n  left: 12px;\n}\n\n.PopUp-Canned-Text {\n  color: #405261;\n\n  font-size: 10px;\n  font-style: normal;\n  font-weight: 400;\n  line-height: 18px; /* 180% */\n}\n.PopUp-Canned-footer {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n}\n.Canned-Advance-text {\n  color: #061522;\n\n  font-size: 14px;\n  font-style: normal;\n  font-weight: 500;\n  line-height: 18px; /* 128.571% */\n}\n.PopUpCanned-button {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n}\n.Canned-Cancel {\n  border-radius: 8px;\n  border: 1px solid #d5dce1;\n  background: #fff;\n  box-shadow: 0px 1px 2px 0px rgba(6, 21, 34, 0.05);\n  padding: 10px 24px;\n  color: #405261;\n  text-align: center;\n\n  font-size: 14px;\n  font-style: normal;\n  font-weight: 500;\n  line-height: 18px;\n  cursor: pointer;\n}\n.Canned-Cancel:hover:not(:disabled) {\n  border-radius: 8px;\n  border: 1px solid #c5ced6;\n  background: #fff;\n  box-shadow: 0 1px 2px 0 rgba(6, 21, 34, 0.05);\n}\n.Canned-Save {\n  border-radius: 8px;\n  background: #148dfd;\n  box-shadow: 0px 1px 2px 0px rgba(6, 21, 34, 0.05);\n  border: none;\n  padding: 11px 32px;\n  color: #fff;\n  text-align: center;\n\n  font-size: 14px;\n  font-style: normal;\n  font-weight: 500;\n  line-height: 18px;\n  cursor: pointer;\n}\n.Canned-Save:disabled {\n  border-radius: 8px;\n  border: 1px solid #c5ced6;\n  background: #f9fafa;\n  color: #93a1b0;\n  box-shadow: 0 1px 2px 0 rgba(6, 21, 34, 0.05);\n  cursor: not-allowed;\n}\n.Canned-Save:hover:not(:disabled) {\n  background: #0077cc;\n}\n.Caneed-responseInput-Container {\n  margin: 20px 0px 30px;\n}\n\n.LoaderMenu-Container {\n  border-radius: 8px;\n  border: 1px solid #d5dce1;\n  background: #fff;\n  box-shadow: 0px 15px 20px 0px rgba(6, 21, 34, 0.05);\n  padding: 16px;\n}\n.ChatMenu-Container {\n  display: flex;\n  gap: 8px;\n}\n.Chat-MessageMenu-Container {\n  position: relative;\n  right: 2%;\n  display: flex;\n  align-items: center;\n}\n.chatbubble-text {\n  color: #405261;\n\n  font-size: 14px;\n  font-style: normal;\n  font-weight: 400;\n  line-height: normal;\n}\n.chatbubble-textdelete {\n  color: #ff4d4f;\n\n  font-size: 14px;\n  font-style: normal;\n  font-weight: 400;\n  line-height: normal;\n}\n.typing-indicator {\n  /* position: absolute;\n  bottom: 0; */\n  color: #888;\n  background-color: #fff;\n  font-size: 14px;\n  width: 100%;\n}\n@media screen and (min-width: 1600px) {\n  .ChatSideBar-Main-Container {\n    width: 26em;\n  }\n  .nathan-johnes {\n    max-width: 300px;\n  }\n  .sidebar-content01 {\n    max-width: 350px;\n  }\n  .nathan-johnes:hover {\n    background: none;\n    z-index: 0;\n    position: relative;\n    top: 0;\n    left: 0;\n    width: 100%;\n    max-width: 100%;\n  }\n  .ChatSideBar-Content-Container {\n    padding-right: 32px;\n  }\n}\n.private-message .Private-Message-Content {\n  background: #fff7e6;\n  color: #061522;\n  border-radius: 16px 16px 0px 16px;\n  font-size: 14px;\n  font-style: normal;\n  font-weight: 400;\n  line-height: 18px;\n  white-space: pre-wrap;\n  overflow-wrap: break-word;\n}\n.private-message {\n  background: #fff7e6;\n  color: #061522;\n}\n.ChatSidear-customer p {\n  margin: 0; /* Remove default paragraph margin */\n  display: flex;\n  align-items: center; /* Ensure icon inside also centers */\n}\n.custom-time-tooltip-wrapper {\n  position: relative;\n  display: inline-block;\n}\n/* Portaled to <body> so the thread's clipping/stacking contexts cannot cut it off.\n   Position comes from CustomTimeTooltip.js. */\n.custom-time-tooltip {\n  position: fixed;\n  min-width: 94px;\n  height: 33.899px;\n  padding: 0 10px;\n  box-sizing: border-box;\n  background: #061522;\n  color: #fff;\n  text-align: center;\n  font-family:\n    \"Apercu Pro\", \"Apercu Mono Pro Medium\", \"Apercu Mono Pro Bold\", Arial,\n    sans-serif;\n  font-size: 12px;\n  font-style: normal;\n  font-weight: 500;\n  line-height: 12px;\n  border-radius: 12px;\n  box-shadow: 0px 4px 8px rgba(0, 0, 0, 0.06);\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  z-index: 1500;\n  pointer-events: none;\n}\n.custom-time-tooltip::after {\n  content: \"\";\n  position: absolute;\n  top: 100%;\n  left: var(--tooltip-arrow-left, 50%);\n  transform: translateX(-50%);\n  border-width: 6px;\n  border-style: solid;\n  border-color: #061522 transparent transparent transparent;\n}\n\n/* Flipped under the bubble when there is no room above (avoids overlapping the chat header) */\n.custom-time-tooltip.custom-time-tooltip--below::after {\n  top: auto;\n  bottom: 100%;\n  border-color: transparent transparent #061522 transparent;\n}\n.typing-indicator-dots {\n  display: flex;\n  align-items: center;\n  gap: 4px;\n  height: 16px;\n}\n.typing-dot {\n  width: 8px;\n  height: 8px;\n  border-radius: 50%;\n  background-color: #148dfd;\n  opacity: 0.7;\n  animation: typing-bounce 1.2s infinite ease-in-out;\n}\n.typing-dot:nth-child(2) {\n  animation-delay: 0.2s;\n}\n.typing-dot:nth-child(3) {\n  animation-delay: 0.4s;\n}\n@keyframes typing-bounce {\n  0%,\n  80%,\n  100% {\n    transform: scale(0.8);\n    opacity: 0.7;\n  }\n  40% {\n    transform: scale(1.2);\n    opacity: 1;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
